package oldframes.editors

import ru.it_mozaika.sender.common.EMAIL_REGEX
import bootstrap.*
import oldcomponents.*
import oldcomponents.dnd.*
import oldcomponents.page.PageContentProps
//import oldframes.editors.email.settings.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import js.core.jso
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.css.*
import kotlinx.css.Position
import kotlinx.css.properties.*
import kotlinx.html.*
import kotlinx.html.ButtonType
import kotlinx.html.js.*
import org.w3c.dom.*
import org.w3c.dom.events.Event
import org.w3c.dom.events.MouseEvent
import react.*
import react.dom.*
import react.router.dom.useSearchParams
import react.router.useNavigate
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import styled.*
import kotlin.Float
import kotlin.math.max

val availableFonts = mapOf(
    "Arial, sans-serif" to "Arial",
    "'Courier New', monospace" to "Courier New",
    "Georgia, serif" to "Georgia",
    "'Times New Roman', serif" to "Times New Roman",
    "'Trebuchet MS', sans-serif" to "Trebuchet MS",
    "Verdana, sans-serif" to "Verdana",
)

val emailTemplateEditorFrame = fc<PageContentProps> { props ->

    kotlinext.js.require(".//assets/css/elisyam-1.5.min.css")
    kotlinext.js.require(".//assets/vendors/css/base/bootstrap.min.css")

    var isSidebarOpened by useState(true)

    val navigate = useNavigate()

    val (searchParams, setSearchParams) = useSearchParams()
    var templateId by useState(searchParams["template"])
    var campaignId by useState(searchParams["campaign"])
    var variantId  by useState(searchParams["variant"]?.toIntOrNull())

    var template by useState(EmailTemplate.BlockEditor())

    var savedRows by useState(listOf<EmailTemplateRowData>())
    fun updateSavedRows() {
        Http.get("/templates/rows") { response ->
            response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                return@get
            }
            savedRows = response.body()
        }
    }
    useEffectOnce {
        updateSavedRows()
    }

    fun loadTemplate() {
        val params = when {
            templateId != null -> mapOf("template" to templateId.orEmpty())
            campaignId != null -> mapOf("campaign" to campaignId.orEmpty(), "variant" to ((variantId ?: 1) - 1).toString())
            else -> return
        }
        Http.get("/templates/item", params) { response ->
            response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                return@get
            }
            when (val result = response.body<EmailTemplateWithName>().template) {
                is EmailTemplate.BlockEditor -> { template = result }
                else -> { showNotification("Неправильный тип шаблона!", NotyType.Error) }
            }
        }
    }

//    useEffectOnce {
//        loadTemplate()
//    }
    useEffect(templateId, campaignId, variantId) {
        loadTemplate()
    }

    var saveDialogShow by useState(false)
    var saveDialogNewTemplate by useState(true)
    var saveDialogTemplateName by useState("")
    var saveDialogSelectedCampaign by useState("")
    var saveDialogCampaigns by useState(mapOf<String, EmailCampaignTitle>())
    useEffectOnce {
        Http.get(
            "/campaigns",
            builder = {
                url {
                    parameters.append("rows", "-1")
                    parameters.appendAll("status", listOf(EmailCampaignStatus.Template.name))
                }
            }
        ) { response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            val result = response.body<List<EmailCampaignTitle>>()
            saveDialogCampaigns = result.associateBy { it.id }
        }
    }
    useEffect(saveDialogShow) {
        if (!saveDialogShow) {
            saveDialogNewTemplate = true
            saveDialogTemplateName = ""
            saveDialogSelectedCampaign = ""
        }
    }

    var testEmailDialogShow by useState(false)

    var activeTab by useState(0)
    var settings by useState(EmailTemplatePageSettings())

    var mobileMode by useState(false)
    var previewMode by useState(false)

    var selectedElement by useState(Triple(-1, -1, -1))
    val parentRef = useRef<HTMLDivElement>()
    val menuRef = useRef<HTMLDivElement>()
//    useEffect {
//        val handleClickEvent: ((Event) -> Unit) = { e: Event ->
//            (e.target as? HTMLElement)?.let { el ->
//                if (parentRef.current?.contains(el) != true && menuRef.current?.contains(el) != true) {
//                    selectedElement = Triple(-1, -1, -1)
//                }
//            }
////            if (parentRef.current?.contains(e.target?.no) == false) {
////
////            }
////            if ((e.target as? HTMLElement)?.hasClass("container-fluid") == true) {
////                selectedElement = Triple(-1, -1, -1)
////            }
////            (e.target as? HTMLElement)?.hasClass("container-fluid")?.lowercase()?.let { id ->
////                if (!id.startsWith("block")
////                    && !id.startsWith("column")
////                    && !id.startsWith("row")
////                    && (selectedElement.first >= 0 || selectedElement.second >= 0 || selectedElement.third >= 0)) {
////                        println("handleClickEvent $id")
////                    selectedElement = Triple(-1, -1, -1)
////                }
////            }
//        }
//        document.addEventListener("mousedown", handleClickEvent)
//        cleanup { document.removeEventListener("mousedown", handleClickEvent) }
//    }

    var rows by useState(
        listOf(
            EmailTemplateRow(),
//            EmailTemplateRow(columns = listOf(EmailTemplateColumn(6), EmailTemplateColumn(6))),
//            EmailTemplateRow(columns = listOf(EmailTemplateColumn(3), EmailTemplateColumn(9))),
//            EmailTemplateRow(columns = listOf(EmailTemplateColumn(3), EmailTemplateColumn(6), EmailTemplateColumn(3))),
//            EmailTemplateRow(columns = listOf(EmailTemplateColumn(2), EmailTemplateColumn(5), EmailTemplateColumn(5))),
//            EmailTemplateRow(columns = listOf(EmailTemplateColumn(2), EmailTemplateColumn(2), EmailTemplateColumn(8))),
//            EmailTemplateRow(columns = listOf(EmailTemplateColumn(2), EmailTemplateColumn(2), EmailTemplateColumn(4), EmailTemplateColumn(4))),
//            EmailTemplateRow(columns = listOf(EmailTemplateColumn(2), EmailTemplateColumn(6), EmailTemplateColumn(2), EmailTemplateColumn(2))),
//            EmailTemplateRow(columns = listOf(EmailTemplateColumn(2), EmailTemplateColumn(2), EmailTemplateColumn(2), EmailTemplateColumn(2), EmailTemplateColumn(2), EmailTemplateColumn(2))),
        )
    )

//    useEffect(rows) {
//
//        CoroutineScope(Dispatchers.Unconfined).launch {
//            rows.forEachIndexed { rowIdx, row ->
//                row.columns.forEachIndexed { columnIdx, column ->
//                    column.blocks.forEachIndexed { blockIdx, block ->
//
//                    }
//                }
//            }
//        }
//    }


    useEffect(template) {
//        selectedElement = Triple(-1, -1, -1)
        settings = template.settings.copy()
        rows = template.rows.toList()
    }

    var templateSaved by useState(false)
    useEffect(template, rows, settings) {
        templateSaved = (templateId != null || campaignId != null) && template.rows == rows && template.settings == settings
    }

    useEffect(settings.contentBackgroundColor) {
        rows = rows.map { it.copy(options = it.options.copy(foregroundColor = settings.contentBackgroundColor)) }
    }

    fun moveRow(row: EmailTemplateRow, fromIndex: Int, toIndex: Int, isAbove: Boolean, isCopy: Boolean) {
//        val index = itm.index as Int

//        println("moveRow $fromIndex $toIndex $isAbove")
        var resultToIndex = if (isAbove) toIndex else toIndex + 1
        if (!isCopy && resultToIndex == fromIndex)
            return

        val result = rows.toMutableList()
        val item = when {
            fromIndex < 0 -> row //EmailTemplateRow(columns = (itm.columns as Array<Int>).map { EmailTemplateColumn(it) })
            isCopy -> result[fromIndex].let { r ->
                r.copy(
                    options = r.options.copy(),
                    columns = r.columns.map { c ->
                        c.copy(
                            size = c.size,
                            blocks = c.blocks.map { b ->
                                when (b) {
                                    is EmailTemplateBlock.Button -> b.copy()
                                    is EmailTemplateBlock.Header -> b.copy()
                                    is EmailTemplateBlock.Html -> b.copy()
                                    is EmailTemplateBlock.Image -> b.copy()
                                    is EmailTemplateBlock.Video -> b.copy()
                                    is EmailTemplateBlock.List -> b.copy()
                                    is EmailTemplateBlock.Paragraph -> b.copy()
                                    is EmailTemplateBlock.Separator -> b.copy()
                                    is EmailTemplateBlock.Spacer -> b.copy()
                                    is EmailTemplateBlock.Text -> b.copy()
                                }
                            }
                        )
                    }
                )
            }
            else -> {
                if (resultToIndex > fromIndex) {
                    resultToIndex--
                }
                result.removeAt(fromIndex)
            }
        }
        if (resultToIndex >= result.size) {
            result.add(item)
        } else {
            result.add(max(resultToIndex, 0), item)
        }
        rows = result
    }

//    fun moveBlock(fromRowIndex: Int, toRowIndex: Int, fromColumnIndex: Int, toColumnIndex: Int, fromBlockIndex: Int, toBlockIndex: Int, block: EmailTemplateBlock, isCopy: Boolean) {
//
//    }
    val moveBlock = useCallback(rows) moveBlock@{ fromRowIndex: Int, toRowIndex: Int, fromColumnIndex: Int, toColumnIndex: Int, fromBlockIndex: Int, toBlockIndex: Int, block: EmailTemplateBlock, isCopy: Boolean ->

        if (fromRowIndex == toRowIndex && fromColumnIndex == toColumnIndex && fromBlockIndex == toBlockIndex && !isCopy) {
            return@moveBlock
        }
        val newBlock = if (isCopy) {
            when (block) {
                is EmailTemplateBlock.Button -> block.copy()
                is EmailTemplateBlock.Header -> block.copy()
                is EmailTemplateBlock.Html -> block.copy()
                is EmailTemplateBlock.Image -> block.copy()
                is EmailTemplateBlock.Video -> block.copy()
                is EmailTemplateBlock.List -> block.copy()
                is EmailTemplateBlock.Paragraph -> block.copy()
                is EmailTemplateBlock.Separator -> block.copy()
                is EmailTemplateBlock.Spacer -> block.copy()
                is EmailTemplateBlock.Text -> block.copy()
            }
        } else {
            block
        }

        val newRows = rows.toMutableList()

        var resultBlockIndex = toBlockIndex
        if (!isCopy && fromRowIndex >= 0 && fromColumnIndex >= 0) {
            val newColumns = newRows[fromRowIndex].columns.toMutableList()
            val newBlocks = newColumns[fromColumnIndex].blocks.minus(block).toList()

            if (fromRowIndex == toRowIndex && fromColumnIndex == toColumnIndex && fromBlockIndex in 0 until resultBlockIndex) {
                resultBlockIndex--
            }
            newColumns[fromColumnIndex] = newColumns[fromColumnIndex].copy(blocks = newBlocks)
            newRows[fromRowIndex] = newRows[fromRowIndex].copy(columns = newColumns.toList())
        }

//        println("size: ${toRowIndex} ${newRows.size}")
//        val newRow = newRows.removeAt(toRowIndex)
        val newRowColumns = newRows[toRowIndex].columns.toMutableList()
        val newBlocks = newRowColumns[toColumnIndex].blocks.toMutableList()

        if (resultBlockIndex < 0)
            resultBlockIndex = toBlockIndex

        if (resultBlockIndex < 0 || resultBlockIndex >= newBlocks.size) {
            newBlocks.add(newBlock)
        } else {
            newBlocks.add(resultBlockIndex, newBlock)
        }

        newRowColumns[toColumnIndex] = newRowColumns[toColumnIndex].copy(blocks = newBlocks.toList())
        newRows[toRowIndex] = newRows[toRowIndex].copy(columns = newRowColumns.toList())
        rows = newRows
    }

    val mb = useCallback(rows) {
        return@useCallback moveBlock
    }
//    fun moveBlock(newRows: MutableList<EmailTemplateRow>, fromRowIndex: Int, toRowIndex: Int, fromColumnIndex: Int, toColumnIndex: Int, fromBlockIndex: Int, toBlockIndex: Int, block: EmailTemplateBlock, isCopy: Boolean = false) {
//
//        if (fromRowIndex == toRowIndex && fromColumnIndex == toColumnIndex && fromBlockIndex == toBlockIndex && !isCopy) {
//            return
//        }
//        val newBlock = if (isCopy) {
//            when (block) {
//                is EmailTemplateBlock.Button -> block.copy()
//                is EmailTemplateBlock.Header -> block.copy()
//                is EmailTemplateBlock.Html -> block.copy()
//                is EmailTemplateBlock.Image -> block.copy()
//                is EmailTemplateBlock.List -> block.copy()
//                is EmailTemplateBlock.Paragraph -> block.copy()
//                is EmailTemplateBlock.Separator -> block.copy()
//                is EmailTemplateBlock.Spacer -> block.copy()
//                is EmailTemplateBlock.Text -> block.copy()
//            }
//        } else {
//            block
//        }
//
//        var resultBlockIndex = toBlockIndex
//        if (!isCopy && fromRowIndex >= 0 && fromColumnIndex >= 0) {
//            val newColumns = newRows[fromRowIndex].columns.toMutableList()
//            val newBlocks = newColumns[fromColumnIndex].blocks.minus(block).toList()
//
//            if (fromRowIndex == toRowIndex && fromColumnIndex == toColumnIndex && fromBlockIndex in 0 until resultBlockIndex) {
//                resultBlockIndex--
//            }
//            newColumns[fromColumnIndex] = newColumns[fromColumnIndex].copy(blocks = newBlocks)
//            newRows[fromRowIndex] = newRows[fromRowIndex].copy(columns = newColumns.toList())
//        }
//
//        println("size: ${toRowIndex} ${newRows.size}")
////        val newRow = newRows.removeAt(toRowIndex)
//        val newRowColumns = newRows[toRowIndex].columns.toMutableList()
//        val newBlocks = newRowColumns[toColumnIndex].blocks.toMutableList()
//
//        if (resultBlockIndex < 0)
//            resultBlockIndex = toBlockIndex
//
//        if (resultBlockIndex < 0 || resultBlockIndex >= newBlocks.size) {
//            newBlocks.add(newBlock)
//        } else {
//            newBlocks.add(resultBlockIndex, newBlock)
//        }
//
//        newRowColumns[toColumnIndex] = newRowColumns[toColumnIndex].copy(blocks = newBlocks.toList())
//        newRows[toRowIndex] = newRows[toRowIndex].copy(columns = newRowColumns.toList())
//        rows = newRows
//    }

    child(oldcomponents.header) {
        attrs {
            isExtended = isSidebarOpened
            onExtendButtonClick = {
                isSidebarOpened = !isSidebarOpened
            }
            menuItems = {
                with(it) {
                    val previewIdParams = when {
                        templateId != null -> "template=$templateId"
                        campaignId != null -> "campaign=$campaignId&variant=${variantId ?: 1}"
                        else -> null
                    }
                    button(type = ButtonType.button, classes = "btn btn-outline-primary") {
                        attrs.disabled = previewIdParams == null
                        attrs.onClickFunction = {
                            previewMode = !previewMode
                        }
                        i("la la-eye") {}
                        +"Предпросмотр"
                    }
                    a(previewIdParams?.let { "/templates/preview?$it" }, "_blank", classes = "mr-2") {
//                        if (previewIdParams == null) {
//                            attrs.jsStyle {
//                                pointerEvents = "none"
//                            }
//                        }
                        button(type = ButtonType.button, classes = "btn btn-outline-primary") {
                            attrs.disabled = previewIdParams == null
                            i("la la-eye") {}
                            +"Предпросмотр (в новой вкладке)"
                        }
                    }
                    button(type = ButtonType.button, classes = "mr-2 btn btn-outline-primary") {
                        attrs.disabled = previewIdParams == null || !templateSaved
                        attrs.onClickFunction = {
                            testEmailDialogShow = true
                        }
                        i("la la-send-o") {}
                        +"Тестовое письмо"
                    }
                    button(type = ButtonType.button, classes = "mr-2 btn btn-outline-success") {
//                        attrs.disabled = templateSaved
                        attrs.onClickFunction = {
                            if (templateId == null && campaignId == null) {
                                saveDialogShow = true
                            } else {
                                val templateToSave = EmailTemplate.BlockEditor(settings, rows)
                                Http
                                    .post(
                                        "/templates/item",
                                        EmailTemplateWithName("", templateToSave),
                                        {
                                            contentType(ContentType.Application.Json)
                                            if (campaignId != null) {
                                                parameter("campaign", campaignId)
                                                parameter("variant", (variantId ?: 1).toString())
                                            } else {
                                                parameter("template", templateId.orEmpty())
                                            }
                                        }
                                    ) { response ->
                                        response.checkResponseError()?.let { error ->
                                            showNotification(error, NotyType.Error)
                                            return@post
                                        }
                                        template = templateToSave
                                    }
                            }
                        }
                        i("la la-save") {}
                        +"Сохранить"
                    }
                }
            }
        }
    }


    var divHeight by useState(0)
    fun updateHeight() {
        menuRef.current?.let { div ->
            if (div.clientHeight != 0 && divHeight != div.clientHeight - 54) {
                divHeight = div.clientHeight - 54
            }
        }
    }
    useEffect {
        val listener = { _: Event -> updateHeight() }
        window.addEventListener("resize", listener)
        cleanup { window.removeEventListener("resize", listener) }
    }
    useEffect(menuRef.current) { updateHeight() }

    DndProvider {
        attrs.backend = HTML5Backend

        div("page-content d-flex align-items-stretch") {
            styledDiv {
                attrs.jsStyle {
                    display = if (previewMode) "none" else "block"
                }
                css {
                    position = Position.fixed
                    height = 100.pct
                    top = 0.px
                    zIndex = 999
                    transition("all", 0.2.s, Timing.ease)
                    paddingTop = 70.px
                    width = 420.px
                    minWidth = 420.px
                    maxWidth = 420.px
//                backgroundColor = Color.white
                }

                styledDiv {
                    ref = menuRef
                    css {
                        classes.add("widget has-shadow")
                        height = 100.pct
                        paddingTop = 10.px

                        put("-webkit-touch-callout", "none")
                        put("-webkit-user-select", "none")
                        put("-khtml-user-select", "none")
                        put("-moz-user-select", "none")
                        put("-ms-user-select", "none")
                        put("user-select", "none")
                    }
                    Nav {
                        attrs.activeKey = activeTab
                        attrs.onSelect = { key, _ ->
                            if (activeTab == 2 && selectedElement.first >= 0) {
                                selectedElement = Triple(-1, -1, -1)
                            }
                            activeTab = (key as String).toInt()
                        }
                        attrs.variant = "tabs"
                        attrs.fill = true

                        NavItem {
                            NavLink {
                                attrs.eventKey = 0
                                attrs.role = "tab"
                                +"Содержимое"
                            }
                        }
                        NavItem {
                            NavLink {
                                attrs.eventKey = 1
                                attrs.role = "tab"
                                +"Строки"
                            }
                        }
                        NavItem {
                            NavLink {
                                attrs.eventKey = 2
                                attrs.role = "tab"
                                +"Настройки"
                            }
                        }
                    }
                    styledDiv {
                        css {
                            position = Position.relative
                            overflow = Overflow.hidden
                            width = 100.pct
                            height = LinearDimension.auto
                            if (divHeight > 0) {
                                minHeight = divHeight.px
                                maxHeight = divHeight.px
                            }
                        }
                        styledDiv {
                            css {
                                position = Position.relative
                                overflow = Overflow.scroll

                                if (divHeight > 0) {
                                    minHeight = divHeight.px
                                    maxHeight = divHeight.px
                                }
                            }

                            TabContent {
                                TabPane {
                                    attrs.active = activeTab == 0
                                    div("row flex-row p-4") {
                                        listOf(
                                            Triple(EmailTemplateBlock.Header(), "la la-header", "Заголовок"),
                                            Triple(EmailTemplateBlock.Paragraph(), "la la-paragraph", "Параграф"),
                                            Triple(EmailTemplateBlock.List(), "la la-list", "Список"),
                                            Triple(EmailTemplateBlock.Image(), "la la-image", "Картинка"),
                                            Triple(EmailTemplateBlock.Video(), "la la-youtube-play", "YouTube видео"),
                                            Triple(EmailTemplateBlock.Button(), "la la-square-o", "Кнопка"),
                                            Triple(EmailTemplateBlock.Separator(), "la la-minus", "Разделитель"),
                                            Triple(EmailTemplateBlock.Spacer(), "la la-unsorted", "Спейсер"),
                                            Triple(EmailTemplateBlock.Text(), "la la-font", "Текст"),
                                            Triple(EmailTemplateBlock.Html(), "la la-code", "HTML/Таблицы"),
//                                                "" to "la la-paragraph" to "Параграф",
//                                                "" to "la la-list" to "Список",
//                                                "" to "la la-image" to "Картинка",
//                                                "" to "la la-square-o" to "Кнопка",
//                                                "" to "la la-minus" to "Разделитель",
//                                                "" to "la la-unsorted" to "Спейсер",
//                                                "" to "la la-font" to "Текст",
//                                                "" to "la la-code" to "HTML/Таблицы",
                                        ).forEach { (type, icon, title) ->
                                            child(fc {
                                                BlockButton {
                                                    attrs.block = type
                                                    attrs.icon = icon
                                                    attrs.title = title
                                                    attrs.onMove = useCallback(rows) { fromRowIndex: Int, toRowIndex: Int, fromColumnIndex: Int, toColumnIndex: Int, fromBlockIndex: Int, toBlockIndex: Int, block: EmailTemplateBlock, isCopy: Boolean ->
                                                        moveBlock(fromRowIndex, toRowIndex, fromColumnIndex, toColumnIndex, fromBlockIndex, toBlockIndex, block, isCopy)
                                                    }

                                                }

                                            })

                                        }
                                    }
                                }
                                TabPane {
                                    attrs.active = activeTab == 1
                                    child(fc {
                                        var rowsType by useState("empty")
                                        val types = mapOf(
                                            "empty" to "Пустые строки",
                                            "saved" to "Сохраненные строки"
                                        )
                                        div("form-group row d-flex align-items-center mb-5") {
                                            div("col-12 pl-4 pr-4 mt-2") {
                                                child(dropdownSelect) {
                                                    attrs {
                                                        dropdownOpenDefault = false
                                                        multiSelect = false
                                                        showFilter = true
                                                        currentValue = mapOf(rowsType to types[rowsType].orEmpty())
                                                        selectValues = types.map { it.key to it.value }
                                                        onSave = {
                                                            rowsType = it.keys.firstOrNull().orEmpty()
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        when (rowsType) {
                                            "empty" -> {
                                                listOf(
                                                    listOf(12),
                                                    listOf(3, 9),
                                                    listOf(4, 8),
                                                    listOf(6, 6),
                                                    listOf(8, 4),
                                                    listOf(9, 3),
                                                    listOf(4, 4, 4),
                                                    listOf(3, 3, 6),
                                                    listOf(3, 3, 6),
                                                    listOf(3, 6, 3),
                                                    listOf(6, 3, 3),
                                                    listOf(3, 3, 3, 3),
                                                    listOf(2, 2, 2, 2, 2, 2),
                                                ).forEach { columns ->
                                                    child(fc {
                                                        RowButton {
                                                            attrs.columns = columns
                                                            attrs.onMoveRow = useCallback(rows) { itm: dynamic, fromIndex: Int, toIndex: Int, isAbove: Boolean, isCopy: Boolean ->
                                                                moveRow(EmailTemplateRow(options = EmailTemplateRowOptions(foregroundColor = settings.contentBackgroundColor), columns = (itm.columns as Array<Int>).map { EmailTemplateColumn(it) }), fromIndex, toIndex, isAbove, isCopy)
//                                                moveBlock(fromRowIndex, toRowIndex, fromColumnIndex, toColumnIndex, fromBlockIndex, toBlockIndex, block, isCopy)
                                                            }
                                                        }
                                                    })
                                                }
                                            }
                                            "saved" -> {
                                                savedRows.forEach { data ->
                                                    child(fc {
                                                        RowButton {
                                                            attrs.columns = data.row.columns.map { it.size }
                                                            attrs.onMoveRow = useCallback(rows) { itm: dynamic, fromIndex: Int, toIndex: Int, isAbove: Boolean, isCopy: Boolean ->
                                                                moveRow(
                                                                    data.row.copy(
                                                                        options = data.row.options.copy(),
                                                                        columns = data.row.columns.map { c ->
                                                                            c.copy(
                                                                                size = c.size,
                                                                                blocks = c.blocks.map { b ->
                                                                                    when (b) {
                                                                                        is EmailTemplateBlock.Button -> b.copy()
                                                                                        is EmailTemplateBlock.Header -> b.copy()
                                                                                        is EmailTemplateBlock.Html -> b.copy()
                                                                                        is EmailTemplateBlock.Image -> b.copy()
                                                                                        is EmailTemplateBlock.Video -> b.copy()
                                                                                        is EmailTemplateBlock.List -> b.copy()
                                                                                        is EmailTemplateBlock.Paragraph -> b.copy()
                                                                                        is EmailTemplateBlock.Separator -> b.copy()
                                                                                        is EmailTemplateBlock.Spacer -> b.copy()
                                                                                        is EmailTemplateBlock.Text -> b.copy()
                                                                                    }
                                                                                }
                                                                            )
                                                                        }
                                                                    ),
                                                                    fromIndex,
                                                                    toIndex,
                                                                    isAbove,
                                                                    isCopy
                                                                )
                                                            }
                                                            attrs.name = data.name
                                                            attrs.onDelete = {
                                                                Http.delete("/templates/rows", mapOf("id" to data.id)) { response ->
                                                                    updateSavedRows()
                                                                    response.checkResponseError()?.let { error ->
                                                                        showNotification(error, NotyType.Error)
                                                                        return@delete
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    })
                                                }
                                            }
                                            else -> {}
                                        }

                                    })

                                }
                                TabPane {
                                    attrs.active = activeTab == 2

                                    val (rowIdx, columnIdx, blockIdx) = selectedElement
                                    when {
                                        rowIdx >= 0 && columnIdx >= 0 && blockIdx >= 0 -> {
                                            rows.getOrNull(rowIdx)?.columns?.getOrNull(columnIdx)?.let { column ->
                                                column.blocks.getOrNull(blockIdx)?.let { block ->
                                                    fun onChange(newBlock: EmailTemplateBlock) {
                                                        val row = rows[rowIdx]
                                                        val blocks = column.blocks.minus(block).toMutableList()

                                                        blocks.add(blockIdx, newBlock)
                                                        val columns = row.columns.minus(column).toMutableList()
                                                        columns.add(columnIdx, column.copy(blocks = blocks.toList()))
                                                        val rowsResult = rows.toList().minus(row).toMutableList()
                                                        rowsResult.add(rowIdx, row.copy(columns = columns.toList()))
                                                        rows = rowsResult
                                                    }

                                                    fun onDataSourceChange(newDataSource: DataSource) {
                                                        val row = rows[rowIdx]
                                                        val columns = row.columns.minus(column).toMutableList()
                                                        columns.add(columnIdx, column.copy(dataSource = newDataSource))
                                                        val rowsResult = rows.toList().minus(row).toMutableList()
                                                        rowsResult.add(rowIdx, row.copy(columns = columns.toList()))
                                                        rows = rowsResult
                                                    }

//                                                    when (block) {
//                                                        is EmailTemplateBlock.Header -> HeaderSettings {
//                                                            attrs.block = block
//                                                            attrs.onChange = ::onChange
//
//                                                            attrs.dataSource = column.dataSource
//                                                            attrs.onDataSourceChange = ::onDataSourceChange
//                                                        }
//                                                        is EmailTemplateBlock.Paragraph -> ParagraphSettings {
//                                                            attrs.block = block
//                                                            attrs.onChange = ::onChange
//
//                                                            attrs.dataSource = column.dataSource
//                                                            attrs.onDataSourceChange = ::onDataSourceChange
//                                                        }
//                                                        is EmailTemplateBlock.List -> ListSettings {
//                                                            attrs.block = block
//                                                            attrs.onChange = ::onChange
//
//                                                            attrs.dataSource = column.dataSource
//                                                            attrs.onDataSourceChange = ::onDataSourceChange
//                                                        }
//                                                        is EmailTemplateBlock.Image -> ImageSettings {
//                                                            attrs.block = block
//                                                            attrs.onChange = ::onChange
//
//                                                            attrs.dataSource = column.dataSource
//                                                            attrs.onDataSourceChange = ::onDataSourceChange
//                                                        }
//                                                        is EmailTemplateBlock.Video -> VideoSettings {
//                                                            attrs.block = block
//                                                            attrs.onChange = ::onChange
//
//                                                            attrs.dataSource = column.dataSource
//                                                            attrs.onDataSourceChange = ::onDataSourceChange
//                                                        }
//                                                        is EmailTemplateBlock.Button -> ButtonSettings {
//                                                            attrs.block = block
//                                                            attrs.onChange = ::onChange
//
//                                                            attrs.dataSource = column.dataSource
//                                                            attrs.onDataSourceChange = ::onDataSourceChange
//                                                        }
//                                                        is EmailTemplateBlock.Separator -> SeparatorSettings {
//                                                            attrs.block = block
//                                                            attrs.onChange = ::onChange
//
//                                                            attrs.dataSource = column.dataSource
//                                                            attrs.onDataSourceChange = ::onDataSourceChange
//                                                        }
//                                                        is EmailTemplateBlock.Spacer -> SpacerSettings {
//                                                            attrs.block = block
//                                                            attrs.onChange = ::onChange
//
//                                                            attrs.dataSource = column.dataSource
//                                                            attrs.onDataSourceChange = ::onDataSourceChange
//                                                        }
//                                                        is EmailTemplateBlock.Text -> TextSettings {
//                                                            attrs.block = block
//                                                            attrs.onChange = ::onChange
//
//                                                            attrs.dataSource = column.dataSource
//                                                            attrs.onDataSourceChange = ::onDataSourceChange
//                                                        }
//                                                        is EmailTemplateBlock.Html -> HtmlSettings {
//                                                            attrs.block = block
//                                                            attrs.onChange = ::onChange
//
//                                                            attrs.dataSource = column.dataSource
//                                                            attrs.onDataSourceChange = ::onDataSourceChange
//                                                        }
//                                                    }
                                                }

                                            }
                                        }
                                        rowIdx >= 0 && columnIdx >= 0 -> {
                                            rows.getOrNull(rowIdx)?.columns?.getOrNull(columnIdx)?.let { column ->
                                                renderColumnSettings(column.dataSource) {

                                                }
                                            }
                                        }
                                        rowIdx >= 0 -> {
                                            RowSettings {
                                                attrs.settings = rows[rowIdx].options
                                                attrs.onChange = {
                                                    val result = rows.toMutableList()
                                                    result[rowIdx] = rows[rowIdx].copy(options = it)
                                                    rows = result
                                                }
                                                attrs.columns = rows[rowIdx].columns
                                                attrs.onColumnsChanged = {
                                                    val result = rows.toMutableList()
                                                    result[rowIdx] = rows[rowIdx].copy(columns = it)
                                                    rows = result
                                                }
                                            }
                                        }
                                        else -> {
//                                            PageSettings {
//                                                attrs.settings = settings
//                                                attrs.onChange = { settings = it }
//                                            }
                                        }
                                    }

                                }
                            }
                        }
                    }

                }

            }

            styledDiv {
                attrs.jsStyle {
                    width = if (previewMode) "100%" else "calc(100% - 420px)"
                    if (!previewMode) {
                        marginLeft = 420.px
                    }
                }
                css {
                    position = Position.relative
//                    width = LinearDimension("calc(100% - 420px)")
//                    marginLeft = 420.px
                    minHeight = LinearDimension("calc(100vh - 71px)")
                    transition("all", 0.3.s, Timing.ease)
                }
                div("container-fluid") {
                    styledDiv {
                        css {
                            position = Position.absolute
                            zIndex = 1000
                            top = 10.px
                            left = 10.px
                        }
                        styledDiv {
                            css {
                                position = Position.relative
                                opacity = 0.8
                                transition("opacity", 0.15.s, Timing.easeInOut)
                                hover {
                                    opacity = 1
                                }
                            }
                            div("btn-group") {
                                attrs.role = "group"
                                listOf(
                                    "la la-desktop",
                                    "la-mobile",
                                ).forEachIndexed { idx, icon ->
                                    button(type = ButtonType.button, classes = "btn btn-sm btn-${if (!mobileMode && idx == 0 || mobileMode && idx == 1) "primary" else "secondary"}") {
                                        attrs.onClickFunction = {
                                            mobileMode = idx == 1
                                        }
                                        i(icon) {}
                                    }
                                }
                            }
                        }
                    }

                    div("page-container") {
                        attrs.jsStyle {
                            if (mobileMode) {
                                width = "320px"
                                marginLeft = "calc(50% - 300px)"
                            }
                        }
                        attrs.role = "presentation"
                        ref = parentRef

                        iframe {
                            attrs.jsStyle {
                                display = if (previewMode) "block" else "none"
                                width = "100%"
                                height = "calc(100vh - 130px)"
                            }
                            val previewIdParams = when {
                                templateId != null -> "template=$templateId"
                                campaignId != null -> "campaign=$campaignId&variant=${variantId ?: 1}"
                                else -> null
                            }
                            attrs.src = "/templates/preview?$previewIdParams"
                        }

                        styledDiv {
                            attrs.classes = attrs.classes.plus("email-page")
//                        div("email-page") {

                            attrs.jsStyle {
                                background = settings.backgroundColor

                                display = if (!previewMode) "block" else "none"
                            }

                            RowsContainer {
                                attrs.mobileMode = mobileMode
                                attrs.rows = rows
                                attrs.selectedElement = selectedElement
                                attrs.settings = settings
                                attrs.onElementSelected = { a, b, c -> selectedElement = Triple(a, b, c) }
                                attrs.onRowsChanged = { rows = it }
                            }

//                            rows.forEachIndexed { rowIndex, row ->
//
//                                useMemo(row, rows) {
//                                    rowElement {
//                                        attrs {
//                                            this.settings = settings
//                                            this.row = row
//                                            this.rowIndex = rowIndex
//                                            this.selectedElement = selectedElement
//                                            this.onClick = { a, b, c ->
////                                                props.onElementSelected(a, b, c)
//                                                selectedElement = Triple(a,b,c)
//                                            }
//                                            this.onChange = { newRow ->
//                                                val newRows = rows.toMutableList()
//                                                newRows[rowIndex] = newRow
////                                                props.onRowsChanged(newRows)
//                                                rows = newRows
//                                            }
//                                            this.onDelete = {
////                                                props.onRowsChanged(props.rows.minus(props.rows[rowIndex]))
//                                                rows = rows.minus(rows[rowIndex])
//                                            }
////                this.moveRow = ::moveRow
////                                        this.moveBlock = moveBlock
//                                            this.moveBlock = moveBlock
////                                                { fromRowIndex: Int, toRowIndex: Int, fromColumnIndex: Int, toColumnIndex: Int, fromBlockIndex: Int, toBlockIndex: Int, block: EmailTemplateBlock, isCopy: Boolean ->
////                                                println("mb: ${rows.size}")
////                                                moveBlock(fromRowIndex, toRowIndex, fromColumnIndex, toColumnIndex, fromBlockIndex, toBlockIndex, block, isCopy)
////                                            }
//                                            this.onDrop = { itm, isAbove ->
//
//                                                val index = itm.index as Int
//                                                if (index != rowIndex) {
//                                                    val result = rows.toMutableList()
//                                                    val tmp = if (index != -1) result.removeAt(index) else EmailTemplateRow(columns = (itm.columns as Array<Int>).map { EmailTemplateColumn(it) })
//
//                                                    when {
//                                                        isAbove -> {
//                                                            result.add(if (index != -1 && index < rowIndex) rowIndex - 1 else rowIndex, tmp)
//                                                        }
//                                                        result.size <= rowIndex + 1 -> {
//                                                            result.add(tmp)
//                                                        }
//                                                        else -> {
//                                                            result.add(maxOf(rowIndex + 1, result.size), tmp)
//                                                        }
//                                                    }
////                                                    props.onRowsChanged(result)
//                                                    rows = result
//                                                }
//                                            }
//                                        }
//                                    }
//                                }
//
//                            }
//                            child(fc {
//
////                            rows.forEachIndexed { rowIndex, row ->
////
////                            }
//                            })
//                            println("render rows ${rows.map { r -> r.columns.map { c -> c.blocks.map { b -> b::class.simpleName }} }}")

                        }
                    }

                }
            }
        }
    }

    Modal {
        attrs.size = "lg"
        attrs.show = saveDialogShow
        attrs.onHide = { saveDialogShow = false }
        ModalHeader {
            ModalTitle {
                +"Сохранить новый шаблон?"
            }
        }
        ModalBody {
            div("form-group row d-flex align-items-center mb-5") {
                label("col-3 form-control-label") { +"Сохранить как:" }
                div("col-9") {
                    div("mb-3") {
                        div("styled-radio") {
                            input(InputType.radio, name = "rb-type-template") {
                                attrs.id = "rb-type-template"
                                attrs["checked"] = saveDialogNewTemplate
                                attrs.onChangeFunction = {
                                    (it.target as? HTMLInputElement)?.checked?.let { v ->
                                        saveDialogNewTemplate = true
                                    }
                                }
                            }
                            label {
                                attrs["htmlFor"] = "rb-type-template"
                                +"Новый Email-шаблон"
                            }
                        }
                    }
                    div("mb-3") {
                        div("styled-radio") {
                            input(InputType.radio, name = "rb-type-variant") {
                                attrs.id = "rb-type-variant"
                                attrs["checked"] = !saveDialogNewTemplate
                                attrs.onChangeFunction = {
                                    (it.target as? HTMLInputElement)?.checked?.let { _ ->
                                        saveDialogNewTemplate = false
                                    }
                                }
                            }
                            label {
                                attrs["htmlFor"] = "rb-type-variant"
                                +"Вариант существующей Email-кампании"
                            }
                        }
                    }
                }
            }
            if (saveDialogNewTemplate) {
                div("form-group row d-flex align-items-center mb-5") {
                    label("col-3 form-control-label") { +"Название шаблона:" }
                    div("col-9") {
                        input(InputType.text, classes = "form-control") {
                            attrs.value = saveDialogTemplateName
                            attrs.onChangeFunction = {
                                saveDialogTemplateName = (it.target as? HTMLInputElement)?.value.orEmpty()
                            }
                        }
                    }
                }
            } else {
                div("form-group row d-flex align-items-center mb-5") {
                    label("col-3 form-control-label") { +"Email-кампания:" }
                    div("col-6") {
                        child(dropdownSelect) {
                            attrs {
                                dropdownOpenDefault = false
                                multiSelect = false
                                showFilter = true
                                currentValue = mapOf(saveDialogSelectedCampaign to saveDialogCampaigns[saveDialogSelectedCampaign]?.name.orEmpty())
                                selectValues = saveDialogCampaigns.map { it.key to it.value.name }
                                onSave = {
                                    saveDialogSelectedCampaign = it.keys.firstOrNull().orEmpty()
                                }
                            }
                        }
                    }
                }
            }
        }
        ModalFooter {
            Button {
                attrs.variant = "secondary"
                attrs.onClick = { saveDialogShow = false }
                +"Отмена"
            }
            Button {
                attrs.variant = "primary"
                attrs.onClick = {
                    val templateToSave = EmailTemplate.BlockEditor(settings, rows.toList())
                    val requestCampaignId: String?
                    val requestTemplateName: String?

                    if (saveDialogNewTemplate) {
                        requestCampaignId = null
                        requestTemplateName = saveDialogTemplateName
                    } else {
                        requestCampaignId = saveDialogSelectedCampaign
                        requestTemplateName = null
                    }
                    Http.put("/templates", EmailTemplateCreateRequest(templateToSave, requestCampaignId ?: "", requestTemplateName)) { response ->
                        saveDialogShow = false
                        response.checkResponseError()?.let { error ->
                            showNotification(error, NotyType.Error)
                            return@put
                        }
                        if (response.status == HttpStatusCode.Created) {
                            template = templateToSave
                            val id = response.headers["ID"].orEmpty()
                            response.headers["variant"]?.toIntOrNull()?.let { variant ->
                                campaignId = id
                                variantId = variant
                            } ?: kotlin.run {
                                templateId = id
                            }
                        }
                    }
                }
                +"Сохранить"
            }
        }
    }

    child(fc {
        var testEmailValue by useState("")
        Modal {
            attrs.size = "lg"
            attrs.show = testEmailDialogShow
            attrs.onHide = { testEmailDialogShow = false }
            ModalHeader {
                ModalTitle {
                    +"Введите номер варианта для отправки"
                }
            }
            ModalBody {
                div("form-group row d-flex align-items-center mb-5") {
                    label("col-3 form-control-label") { +"Email получателя:" }
                    div("col-9") {
                        input(InputType.email, classes = "form-control") {
                            attrs.value = testEmailValue
                            attrs.onChangeFunction = {
                                testEmailValue = (it.target as? HTMLInputElement)?.value.orEmpty()
                            }
                        }
                    }
                }
            }
            ModalFooter {
                Button {
                    attrs.variant = "secondary"
                    attrs.onClick = { testEmailDialogShow = false }
                    +"Отмена"
                }
                Button {
                    attrs.variant = "primary"
                    attrs.disabled = !EMAIL_REGEX.matches(testEmailValue)
                    attrs.onClick = {
                        when {
                            campaignId != null -> {
                                Http.get("/campaigns/$campaignId/test-email", mapOf("email" to testEmailValue, "variant" to ((variantId ?: 1) - 1).toString())) { response ->
                                    response.checkResponseError()?.let { error ->
                                        showNotification(error, NotyType.Error)
                                    } ?: kotlin.run {
                                        showNotification("E-mail отправлен", NotyType.Success)
                                    }
                                }
                            }
                            templateId != null -> {
                                Http.get("/templates/$campaignId/test-email", mapOf("email" to testEmailValue, "variant" to ((variantId ?: 1) - 1).toString())) { response ->
                                    response.checkResponseError()?.let { error ->
                                        showNotification(error, NotyType.Error)
                                    } ?: kotlin.run {
                                        showNotification("E-mail отправлен", NotyType.Success)
                                    }
                                }
                            }
                        }
                        testEmailDialogShow = false
                    }
                    +"Отправить"
                }
            }
        }
    })

}

private external interface EmptyColumnDropProps : Props {
    var rowIndex: Int
    var columnIndex: Int
    var maxSize: Float
    var onMove: (Int, Int, Int, Int, Int, Int, EmailTemplateBlock, Boolean) -> Unit
}
private val EmptyColumnDrop = fc<EmptyColumnDropProps> { props ->
    val (blocksDropProps, emptyBlocksDrop) = useDrop<dynamic, dynamic, dynamic>({
        jso {
            accept = "Block"
            drop = { itm, monitor ->
                itm.isAbove = false
                itm.toRowIndex = props.rowIndex
                itm.toColumnIndex = props.columnIndex
                itm.toBlockIndex = 0

                val block = itm.block as EmailTemplateBlock
                val rowIdx = itm.row as Int
                val columnIdx = itm.column as Int
                val blockIdx = itm.index as Int

                val dropResult = monitor.getDropResult()

                val isCopy = dropResult != null && dropResult.dropEffect == "copy"
                if (rowIdx < 0 && columnIdx < 0 && blockIdx < 0) {
                    props.onMove(rowIdx, props.rowIndex, columnIdx, props.columnIndex, blockIdx, -1, block, isCopy)
                }

                itm
            }
            collect = { monitor ->
                jso {
                    this.isOver = monitor.isOver(false)
                }
            }
        }
    })
    styledDiv {
        ref = emptyBlocksDrop
        css {
            width = 100.pct
            height = 100.pct
            minHeight = 71.px
            backgroundColor = Color(if (blocksDropProps.isOver as Boolean) "#17a2b8" else "#a3dcec")
            border(2.px, BorderStyle.dashed, Color(if (blocksDropProps.isOver as Boolean) "#5d5386" else "#17a2b8"))
        }
        div("row d-flex justify-content-center") {
            styledI {
                css {
                    classes.add("la la-arrow-circle-up")
                    fontSize = 2.rem
                    color = Color(if (blocksDropProps.isOver as Boolean) "#5d5386" else "#17a2b8")
                    padding(5.px)
                }
            }
        }
        if (props.maxSize > 33) {
            div("row d-flex justify-content-center") {
                styledLabel {
                    css {
                        fontSize = if (props.maxSize > 40 ) 1.15.rem else 1.rem
                        color = Color(if (blocksDropProps.isOver as Boolean) "#5d5386" else "#17a2b8")
                    }
                    +"Переместите блоки сюда"
                }
            }
        }
    }
}

private external interface DropProps : Props {
    var type: String
    var row: Int
    var column: Int
    var block: Int
    var onDrop: (item: dynamic, isAbove: Boolean) -> Unit
}
private val Drop = fc<DropProps> { props ->
    val (aboveDropProps, aboveDrop) = useDrop<dynamic, dynamic, dynamic>({
        jso {
            accept = props.type
            drop = { itm, _ ->
                itm.isAbove = true
                itm.toRowIndex = props.row
                itm.toColumnIndex = props.column
                itm.toBlockIndex = props.block
//                    onDrop(itm, true)
                itm
            }
            collect = { monitor ->
                jso {
                    this.hide = monitor.getItemType() != props.type
                    this.isOver = monitor.isOver(false)
                }
            }
        }
    })

    val (belowDropProps, belowDrop) = useDrop<dynamic, dynamic, dynamic>({
        jso {
            accept = props.type
            drop = { itm, _ ->
                itm.isAbove = false
                itm.toRowIndex = props.row
                itm.toColumnIndex = props.column
                itm.toBlockIndex = props.block
//                    onDrop(itm, false)
                itm
            }
            collect = { monitor ->
                jso {
                    this.hide = monitor.getItemType() != props.type
                    this.isOver = monitor.isOver(false)
                }
            }
        }
    })


    styledDiv {
        ref = aboveDrop
        attrs.jsStyle {
            if (undefined != aboveDropProps.hide && aboveDropProps.hide as? Boolean == true) {
                display = "none"
            }
            if (aboveDropProps.isOver as Boolean)
                borderTop = "2px solid #5d5386"
        }
        css {
            classes.add("d-flex justify-content-center")
            flexWrap = FlexWrap.wrap
            position = Position.absolute
            height = if (undefined != aboveDropProps.hide && aboveDropProps.hide as? Boolean == true) {
                0.px
            } else {
                50.pct
            }
//                backgroundColor = Color.red.withAlpha(0.2)
            width = 100.pct
            zIndex = 10
        }
        styledDiv {
            attrs.jsStyle {
                display = if (aboveDropProps.isOver as Boolean) "block" else "none"
            }
            css {
                backgroundColor = Color("#5d5386")
                border(2.px, BorderStyle.solid, Color("#5d5386"), 4.px)
                color = Color.white
                height = 17.px
                fontSize = 0.65.rem
                padding(0.px, 1.px)
                marginTop = (-9).px
                zIndex = 10
            }
            +"Переместить сюда"
        }
    }
    styledDiv {
        ref = belowDrop
        attrs.jsStyle {
            if (undefined != belowDropProps.hide && belowDropProps.hide as? Boolean == true) {
                display = "none"
            }
            if (belowDropProps.isOver as Boolean)
                borderBottom = "2px solid #5d5386"
        }
        css {
            classes.add("d-flex justify-content-center")
            flexWrap = FlexWrap.wrap
            position = Position.absolute
            height = if (undefined != belowDropProps.hide && belowDropProps.hide as? Boolean == true) {
                0.px
            } else {
                50.pct
            }
//                backgroundColor = Color.blue.withAlpha(0.2)
            width = 100.pct
            bottom = LinearDimension("0")
            alignContent = Align.flexEnd
            zIndex = 10
        }
        styledDiv {
            attrs.jsStyle {
                display = if (belowDropProps.isOver as Boolean) "block" else "none"
            }
            css {
                backgroundColor = Color("#5d5386")
                border(2.px, BorderStyle.solid, Color("#5d5386"), 4.px)
                color = Color.white
                height = 17.px
                fontSize = 0.65.rem
                padding(0.px, 1.px)
                zIndex = 10
                marginBottom = (-9).px
            }
            +"Переместить сюда"
        }
    }
}


private external interface ColumnSizeSeparatorProps : Props {
    var onDragStart: (kotlinx.html.org.w3c.dom.events.Event) -> Unit
    var onDragEnd: () -> Unit
}
private val ColumnSizeSeparator = fc<ColumnSizeSeparatorProps> { props ->

    styledDiv {
//        attrs.onDragStartFunction = {
//            it.preventDefault()
//            it.stopPropagation()
////            props.onDragStart()
//        }
        attrs {
            onMouseDownFunction = {
                props.onDragStart(it)
            }
        }
//        attrs.onDrag = { e: DragEvent<HTMLDivElement> ->
//            println("onDrag")
////            onDrag(it)
//        }
//        attrs.onDragEndFunction = {
//            println("onDragEnd")
//            it.preventDefault()
//            it.stopPropagation()
////            props.onDragEnd()
//        }
        css {
            height = 44.px
            width = 16.px
            fontSize = 22.px
            color = Color("#2c304d")
            cursor = Cursor.colResize
        }
        attrs.draggable = kotlinx.html.Draggable.htmlTrue
        styledI {
            css {
                        pointerEvents = PointerEvents.none
                classes.add("la la-ellipsis-v")
                marginLeft = (-3).px
                position = Position.relative
                top = LinearDimension("calc(50% - 18px)")
            }
        }
    }
}

private external interface RowSettingsProps : Props {
    var settings: EmailTemplateRowOptions
    var onChange: (EmailTemplateRowOptions) -> Unit
    var columns: List<EmailTemplateColumn>
    var onColumnsChanged: (List<EmailTemplateColumn>) -> Unit
}
private val RowSettings = fc<RowSettingsProps> { props ->
    var colorPicker by useState(-1)

    div("form-group row d-flex justify-content-between align-items-center mt-3 ml-2 mr-2") {
        label("col-6 form-control-label") { +"Цвет фона:" }
        styledLabel {
            css {
                classes.addAll(listOf(
                    "col-5",
                    "form-control-label",
                    "text-center"
                ))
                padding(4.px)
                marginRight = 15.px
                border(4.px, BorderStyle.solid, Color(props.settings.backgroundColor), 6.px)
            }
            attrs.onClickFunction = {
                colorPicker = if (colorPicker != 0) 0 else -1
            }
            +props.settings.backgroundColor
        }
        if (colorPicker == 0) {
            colorPicker(props.settings.backgroundColor, { colorPicker = -1}) {
                props.onChange(props.settings.copy(backgroundColor = it))
            }
        }
    }

    div("form-group row d-flex justify-content-between align-items-center mt-3 ml-2 mr-2") {
        label("col-6 form-control-label") { +"Цвет фона контента:" }
        styledLabel {
            css {
                classes.addAll(listOf(
                    "col-5",
                    "form-control-label",
                    "text-center"
                ))
                padding(4.px)
                marginRight = 15.px
                border(4.px, BorderStyle.solid, Color(props.settings.foregroundColor), 6.px)
            }
            attrs.onClickFunction = {
                colorPicker = if (colorPicker != 1) 1 else -1
            }
            +props.settings.foregroundColor
        }
        if (colorPicker == 1) {
            colorPicker(props.settings.foregroundColor, { colorPicker = -1}) {
                props.onChange(props.settings.copy(foregroundColor = it))
            }
        }
    }

    val aligns = mapOf(
        "top" to "Сверху",
        "middle" to "Центр",
        "bottom" to "Снизу",
    )
    div("form-group row d-flex align-items-center mt-3 ml-2 mr-2") {
        label("col-6 form-control-label") { +"Выравнивание:" }
        div("col-6") {
            child(dropdownSelect) {
                attrs {
                    dropdownOpenDefault = false
                    multiSelect = false
                    showFilter = false
                    currentValue = mapOf(props.settings.verticalAlign to aligns[props.settings.verticalAlign].orEmpty())
                    selectValues = aligns.map { it.key to it.value }
                    onSave = {
                        props.onChange(props.settings.copy(verticalAlign = it.keys.firstOrNull() ?: "top"))
                    }
                }
            }
        }
    }

    div("em-separator separator-dashed mt-5") {}
    div("section-title ml-4") {
        h4 { +"Настройки колонок" }
    }

    val rRef = useRef<HTMLDivElement>()
    var columnSizes by useState(props.columns.map { it.size })
    var dragSeparatorId by useState(-1)
    var startX by useState(-1)

    var selectedColumn by useState(0)

    useEffect(props.columns) {
        selectedColumn = if (selectedColumn < columnSizes.size) selectedColumn else 0
        columnSizes = props.columns.map { it.size }
    }
    useEffect(dragSeparatorId) {
        if (dragSeparatorId < 0 && columnSizes != props.columns.map { it.size }) {
            val cols = props.columns.mapIndexed { idx, column -> column.copy(size = columnSizes[idx])}
//            println(cols)
            props.onColumnsChanged(cols)
        }
    }
    styledDiv {
        ref = rRef
        attrs.id = "columns-size-container"
        attrs.onMouseMoveFunction = {
            if (dragSeparatorId > 0 && startX >= 0) {
                val offset = (it.asDynamic().nativeEvent as MouseEvent).screenX - startX
                val sizeOffset = offset / 15

                val twoColumnSize = columnSizes[dragSeparatorId - 1] + columnSizes[dragSeparatorId]
                if (twoColumnSize > 4) {
                    val newSizes = props.columns.map { it.size }.toMutableList()
                    newSizes[dragSeparatorId - 1] = newSizes[dragSeparatorId - 1] + sizeOffset
                    newSizes[dragSeparatorId] = newSizes[dragSeparatorId] - sizeOffset

                    if (newSizes[dragSeparatorId - 1] < 2) {
                        newSizes[dragSeparatorId - 1] = 2
                        newSizes[dragSeparatorId] = twoColumnSize - 2
                    } else if (newSizes[dragSeparatorId] < 2)  {
                        newSizes[dragSeparatorId - 1] = twoColumnSize - 2
                        newSizes[dragSeparatorId] = 2
                    }

                    columnSizes = newSizes
                }
            }
        }
        attrs.onMouseLeave = {
            if (dragSeparatorId > 0) {
                dragSeparatorId = -1
            }
        }
        attrs.onMouseUpFunction = {
            dragSeparatorId = -1
            startX = -1
        }
        css {
            classes.add("mt-2 ml-4 mr-4 row d-flex justify-content-center")
            minHeight = 64.px
            alignContent = Align.center
            padding(8.px)
            border(2.px, BorderStyle.dashed, Color("#5d5386"), 8.px)
        }
        fun RBuilder.renderColumnSizeDiv(size: Int, columnsCount: Int, isSelected: Boolean, onSelect: () -> Unit) {
            styledDiv {
                attrs.onClickFunction = {
                    onSelect()
                }
                css {
                    margin(2.px)
                    height = 40.px
                    width = ((8-(columnsCount-1)*0.5) * size).pct
//                    width = LinearDimension("calc(${8f * size}% - ${(columnsCount-1) * (12 - 4)}px)")
                    backgroundColor = Color("#5d5386").withAlpha(0.35)
                    border(2.px, if (isSelected) BorderStyle.solid else BorderStyle.dashed, Color("#5d5386").withAlpha(0.5), 4.px)
                    fontSize = if (isSelected) 22.px else 16.px
                    padding(if (isSelected) 2.px else 6.px)
                    color = Color("#2c304d")
                    fontWeight = if (isSelected) FontWeight.w600 else FontWeight.w400
                    textAlign = TextAlign.center
                    cursor = Cursor.pointer
                }
                +size.toString()
            }
        }
//        fun RBuilder.renderColumnSizeSeparator(onDragStart: (Event) -> Unit, onDrag: (Event) -> Unit, onDragEnd: (Event) -> Unit) {
//        }
        for (i in columnSizes.indices) {
            if (i > 0) {
                ColumnSizeSeparator {
                    attrs.onDragStart = {
                        dragSeparatorId = i
                        startX = (it.asDynamic().nativeEvent as MouseEvent).screenX
//                    println("onDragStart")
                    }
                    attrs.onDragEnd = {
                        dragSeparatorId = -1
                    }
                }
            }

            renderColumnSizeDiv(columnSizes[i], columnSizes.size, selectedColumn == i) { selectedColumn = i }
        }

        styledDiv {
            css {
                position = Position.absolute
                width = 100.pct
                marginTop = 8.px
            }
            styledI {
                attrs.jsStyle {
                    color = if (props.columns.first().size >= 4) "#2c304d" else "#a0a0a0"
                }
                css {
                    classes.add("la la-plus-circle")
                    position = Position.absolute
                    backgroundColor = Color.white
                    fontSize = 22.px
                    left = 11.px
                    marginTop = 2.px
                    cursor = Cursor.pointer
                    transform { transition("all", 0.025.s, Timing.ease) }
                    hover {
                        fontSize = 26.px
                        left = 9.px
                        marginTop = 0.px
                        fontWeight = FontWeight.w600
                    }
                }
                attrs.onClickFunction = {
                    if (props.columns.first().size >= 4) {
                        val columns = props.columns.toMutableList()
                        columns.add(0, EmailTemplateColumn(2))
                        columns[1] = columns[1].copy(size = columns[1].size - 2)
                        props.onColumnsChanged(columns)
                    }
                }
            }
            styledI {
                attrs.jsStyle {
                    color = if (props.columns.last().size >= 4) "#2c304d" else "#a0a0a0"
                }
                css {
                    classes.add("la la-plus-circle")
                    position = Position.absolute
                    backgroundColor = Color.white
                    fontSize = 22.px
                    right = 11.px
                    marginTop = 2.px
                    cursor = Cursor.pointer
                    transform { transition("all", 0.025.s, Timing.ease) }
                    hover {
                        fontSize = 26.px
                        right = 9.px
                        marginTop = 0.px
                        fontWeight = FontWeight.w600
                    }
                }
                attrs.onClickFunction = {
                    if (props.columns.last().size >= 4) {
                        val columns = props.columns.toMutableList()
                        columns[columns.size - 1] = columns.last().copy(size = columns.last().size - 2)
                        columns.add(EmailTemplateColumn(2))
                        props.onColumnsChanged(columns)
                    }
                }
            }
        }

    }

    div("row d-flex section-title ml-4 mt-2 justify-content-between") {
        h4 { +"Настройки ${selectedColumn+1} колонки:" }
        styledDiv {
            css { marginRight = 40.px }
            if (props.columns.size > 1 && selectedColumn >= 0) {
                styledSpan {
                    css {
                        color = Color("#e76c90")
                        cursor = Cursor.pointer
                    }
                    i("la la-trash") {}
                    +"Удалить"

                    attrs.onClickFunction = {
                        val columns = props.columns.toMutableList()
                        columns.removeAt(selectedColumn)
                        props.onColumnsChanged(columns)
                        selectedColumn = 0
                    }
                }
            }
        }
    }

    if (selectedColumn < props.columns.size) {
//        DataSourceSettings {
//            attrs.dataSource = props.columns[selectedColumn].dataSource
//            attrs.onChange = {
//                val cols = props.columns.toMutableList()
//                cols[selectedColumn] = cols[selectedColumn].copy(dataSource = it)
//                props.onColumnsChanged(cols)
//            }
//        }
    }

}

private fun RBuilder.renderColumnSettings(source: DataSource, onChange: (DataSource) -> Unit) {
    child(fc {

    })
}

fun RBuilder.colorPicker(color: String, onClose: () -> Unit, onChangeComplete: (String) -> Unit) {
    styledDiv {
        css {
            position = Position.absolute
            right = 18.px
        }
        styledDiv {
            css {
                position = Position.relative
                zIndex = 1000
                top = 150.px
            }
            styledDiv {
                css {
                    position = Position.fixed
                    left = 0.px
                    top = 0.px
                    right = 0.px
                    bottom = 0.px
                }
                attrs.onClickFunction = { onClose() }
            }
            ChromePicker {
                attrs.color = color
                attrs.onChangeComplete = { color, _ ->
                    onChangeComplete(if (color.rgb.a == 1) {
                        color.hex
                    } else {
                        "rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})"
                    })
                }
            }
        }
    }
}


external interface RowProps : Props {
    var mobileMode: Boolean
    var settings: EmailTemplatePageSettings
    var row: EmailTemplateRow
    var rowIndex: Int
    var selectedElement: Triple<Int, Int, Int>
    var onClick: (Int, Int, Int) -> Unit
    var onChange: (EmailTemplateRow) -> Unit
    var onDelete: () -> Unit
    var onSave: () -> Unit
    var moveRow: (dynamic, Int, Int, Boolean, Boolean) -> Unit
    var moveBlock: (Int, Int, Int, Int, Int, Int, EmailTemplateBlock, Boolean) -> Unit
    var onDrop: (dynamic, Boolean) -> Unit
}
val rowElement = fc<RowProps> { props ->
    val (p, drag, preview) = useDrag<dynamic, dynamic, dynamic>({
        jso {
            type = "Row"
            item = jso {
                this.id = "row${props.rowIndex}"
                this.index = props.rowIndex
            }
            collect = {
                jso {
                    this.isDragging = it.isDragging()
                }
            }
            end = { itm, monitor ->

                val dropResult = monitor.getDropResult()

                if (dropResult != null) {
                    val fromRowIndex = itm.index as Int
                    val isAbove = dropResult.isAbove as Boolean
                    val toRowIndex = dropResult.toRowIndex as Int
                    val dropEffect = dropResult.dropEffect

                    props.moveRow(
                        itm,
                        fromRowIndex,
                        toRowIndex,
                        isAbove,
                        dropEffect == "copy"
                    )
                }
            }
        }
    })
    var hover by useState(false)

    styledDiv {
        attrs.id = "Row${props.rowIndex}"
//                                        ref = rowRef
        attrs.onMouseOverFunction = {
//                                            println("id: ${(it.target as? HTMLDivElement)?.id}")
//                                            println("id: ${(it.currentTarget as? HTMLDivElement)?.id}")
            hover = (it.target as? HTMLDivElement)?.id == "Row${props.rowIndex}" || (it.target as? HTMLDivElement)?.className?.contains("rowMove") == true  || (it.target as? HTMLDivElement)?.className?.contains("rowEdit") == true
//                                            if ((it.currentTarget as? HTMLDivElement)?.id == "Row${rowIndex}")
//                                                hover = true
        }
        attrs.onClickFunction = {
//            println("onClick row??")
            if ((it.target as? HTMLDivElement)?.id?.contains("Row") == true) {
                props.onClick(props.rowIndex, -1, -1)
//                selectedElement = Triple(rowIndex, -1, -1)
            }
        }

//                                        attrs.onBlurFunction = {
//                                            println("onBlur row")
//                                            if (selectedElement.first >= 0 && selectedElement.second < 0 && selectedElement.third < 0) {
//                                                selectedElement = Triple(-1, -1, -1)
//                                            }
//                                        }
        attrs.onMouseOutFunction = {
            hover = false
        }
        attrs.onMouseLeave = {
            hover = false
        }
        css {
            width = 100.pct
            boxSizing = BoxSizing.contentBox
            position = Position.relative
            pointerEvents = PointerEvents.auto

//                                    if (mouseOverRow == rowIndex) {
//                                        boxShadow(Color("#a3dcec"), spreadRadius = 2.px)
////                                        border(2.px, BorderStyle.solid, Color("#a3dcec"))
//                                    }
            if (hover || props.selectedElement.first == props.rowIndex && props.selectedElement.second == -1 && props.selectedElement.third == -1) {
                if (hover) {
                    backgroundColor = Color("#17a2b8").withAlpha(0.125)
                }
                boxShadow(Color("#17a2b8"), spreadRadius = 2.px)

                ".rowTitle" {
                    display = Display.block
                }
                ".rowMove" {
                    display = Display.block
                }
//                if (rows.size > 1) {
                    ".rowEdit" {
                        display = Display.block
                    }
//                }
            }
//                                            hover {
//
//                                            }
        }
//                                        attrs.onMouseOverFunction = { mouseOverRow = rowIndex }
//                                        attrs.onMouseOutFunction = { mouseOverRow = rowIndex }
//                                        attrs.onMouseLeave = { mouseOverRow = rowIndex }


        Drop {
            attrs {
                type = "Row"
                row = props.rowIndex
                column = -1
                block = -1
                onDrop = props.onDrop
            }
        }
//        { itm, isAbove ->
//            val index = itm.index as Int
//            if (index != props.rowIndex) {
//                val result = rows.toMutableList()
//                val tmp = if (index != -1) result.removeAt(index) else EmailTemplateRow(columns = (itm.columns as Array<Int>).map { EmailTemplateColumn(it) })
//
//                when {
//                    isAbove -> {
//                        result.add(if (index != -1 && index < rowIndex) rowIndex - 1 else rowIndex, tmp)
//                    }
//                    result.size <= rowIndex + 1 -> {
//                        result.add(tmp)
//                    }
//                    else -> {
//                        result.add(maxOf(rowIndex + 1, result.size), tmp)
//                    }
//                }
//                rows = result.toTypedArray()
//            }
//        }

        styledDiv {
            css {
                classes.add("rowTitle")
                position = Position.absolute
                top = (-26).px
//                                        top = LinearDimension("0")
                right = (-2).px
                backgroundColor = Color("#17a2b8")
                border(2.px, BorderStyle.solid, Color("#17a2b8"))
                borderTopLeftRadius = 4.px
                borderTopRightRadius = 4.px
                borderBottomLeftRadius = 0.px
                borderBottomRightRadius = 0.px
                color = Color.white
                display = Display.none
            }
            +"Строка"
//                                    styledDiv {
//                                        css {
//                                            classes.add("rowTitle")
//                                            position = Position.relative
//                                            top = (-26).px
////                                            right = (-2).px
//                                            backgroundColor = Color("#a3dcec")
//                                            border(2.px, BorderStyle.solid, Color("#a3dcec"))
//                                            borderTopLeftRadius = 4.px
//                                            borderTopRightRadius = 4.px
//                                            borderBottomLeftRadius = 0.px
//                                            borderBottomRightRadius = 0.px
//                                            color = Color("#17a2b8")
//                                            display = Display.none
////                                            opacity = if (mouseOverRow == rowIndex) 1 else 0
//                                        }
//                                        +"Строка"
//                                    }
        }
        styledDiv {
            ref = drag
            css {
                classes.add("rowMove")
                position = Position.absolute
                top = LinearDimension("calc(50% - 15px)")
                backgroundColor = Color("#17a2b8")
                border(4.px, BorderStyle.solid, Color("#17a2b8"))
                borderTopLeftRadius = 0.px
                borderTopRightRadius = 8.px
                borderBottomLeftRadius = 0.px
                borderBottomRightRadius = 8.px
                display = Display.none
                cursor = Cursor.move
                zIndex = 20
            }
//                                    styledDiv {
//                                        css {
//                                            position = Position.relative
//                                            top = LinearDimension("calc(50% - 15px)")
//                                            backgroundColor = Color("#a3dcec")
//                                            border(4.px, BorderStyle.solid, Color("#a3dcec"))
//                                            borderTopLeftRadius = 0.px
//                                            borderTopRightRadius = 8.px
//                                            borderBottomLeftRadius = 0.px
//                                            borderBottomRightRadius = 8.px
//                                        }
//                                        styledI {
//                                            css {
//                                                classes.add("la la-arrows-v")
//                                                color = Color("#17a2b8")
//                                                padding(5.px)
//                                            }
//                                        }
//                                    }
            styledI {
                css {
                    classes.add("la la-arrows-v")
                    color = Color.white
                    padding(5.px)
                    cursor = Cursor.move
                    pointerEvents = PointerEvents.none
                }
            }
        }

        styledDiv {
            attrs.onClickFunction = {
                props.onDelete()
//                rows = rows.toList().minus(row).toTypedArray()
//                selectedElement = Triple(-1, -1, -1)
            }
            css {
                classes.add("rowEdit")
                position = Position.absolute
                top = 10.px
                right = 10.px
                backgroundColor = Color("#17a2b8")
                border(4.px, BorderStyle.solid, Color("#17a2b8"))
                borderTopLeftRadius = 8.px
                borderTopRightRadius = 8.px
                borderBottomLeftRadius = 8.px
                borderBottomRightRadius = 8.px
                display = Display.none
                zIndex = 20
            }
            styledI {
                css {
                    classes.add("la la-trash")
                    color = Color.white
                    padding(5.px)
                    cursor = Cursor.move
                    pointerEvents = PointerEvents.none
                }
            }
        }

        styledDiv {
            attrs.onClickFunction = {
                props.onSave()
//                rows = rows.toList().minus(row).toTypedArray()
//                selectedElement = Triple(-1, -1, -1)
            }
            css {
                classes.add("rowEdit")
                position = Position.absolute
                top = 10.px
                right = 52.px
                backgroundColor = Color("#17a2b8")
                border(4.px, BorderStyle.solid, Color("#17a2b8"))
                borderTopLeftRadius = 8.px
                borderTopRightRadius = 8.px
                borderBottomLeftRadius = 8.px
                borderBottomRightRadius = 8.px
                display = Display.none
                zIndex = 20
            }
            styledI {
                css {
                    classes.add("la la-save")
                    color = Color.white
                    padding(5.px)
                    cursor = Cursor.move
                    pointerEvents = PointerEvents.none
                }
            }
        }


        div("email-row") {
            ref = preview
            attrs.jsStyle {
                width = if (props.mobileMode) "320px" else "${props.settings.contentAreaWidth}px"
                maxWidth = if (props.mobileMode) "320px" else "${props.settings.contentAreaWidth}px"
                background = props.row.options.backgroundColor //props.settings.contentBackgroundColor
                margin = if (props.settings.contentAlign == "left") "inherit" else "auto"
            }
            div("email-columns-container d-flex align-items-${when (props.row.options.verticalAlign) { "top" -> "start"; "middle" -> "center"; else -> "end" }}") {
                attrs.jsStyle {
                    flexWrap = "wrap"
                    backgroundColor = props.row.options.foregroundColor
                }
                props.row.columns.forEachIndexed { columnIndex, column ->
                    val maxSize = if (props.mobileMode) 100.0f else 100.0f * column.size / 12
                    styledDiv {
                        css {
                            flexBasis = FlexBasis("$maxSize%")
                            maxWidth = maxSize.pct
                            paddingTop = 2.px
                            paddingBottom = 2.px
                        }


                        if (column.blocks.isEmpty()) {
                            EmptyColumnDrop {
                                attrs.rowIndex = props.rowIndex
                                attrs.columnIndex = columnIndex
                                attrs.maxSize = maxSize
//                                attrs.onMove = props.moveBlock
                                attrs.onMove = { fromRowIndex: Int, toRowIndex: Int, fromColumnIndex: Int, toColumnIndex: Int, fromBlockIndex: Int, toBlockIndex: Int, block: EmailTemplateBlock, isCopy: Boolean ->
                                    props.moveBlock(fromRowIndex, toRowIndex, fromColumnIndex, toColumnIndex, fromBlockIndex, toBlockIndex, block, isCopy)
                                }
                            }
                        } else {
                            column.blocks.forEachIndexed { blockIndex, block ->
                                blockElement {
                                    attrs {
                                        this.block = block
                                        this.rowIndex = props.rowIndex
                                        this.columnIndex = columnIndex
                                        this.blockIndex = blockIndex
                                        this.selectedElement = props.selectedElement
                                        this.onClick = props.onClick
                                        this.onDelete = {
                                            val newColumns = props.row.columns.toMutableList()
                                            newColumns[columnIndex] = column.copy(blocks = column.blocks.minus(block))
                                            props.onChange(props.row.copy(columns = newColumns))
                                        }
                                        this.onChange = {
                                            val newBlocks = column.blocks.toMutableList()
                                            newBlocks[blockIndex] = it
                                            val newColumns = props.row.columns.toMutableList()
                                            newColumns[columnIndex] = column.copy(blocks = newBlocks)
                                            props.onChange(props.row.copy(columns = newColumns))
                                        }
//                                        this.onMove = props.moveBlock
                                        this.onMove = { fromRowIndex: Int, toRowIndex: Int, fromColumnIndex: Int, toColumnIndex: Int, fromBlockIndex: Int, toBlockIndex: Int, block: EmailTemplateBlock, isCopy: Boolean ->
                                            props.moveBlock(fromRowIndex, toRowIndex, fromColumnIndex, toColumnIndex, fromBlockIndex, toBlockIndex, block, isCopy)
                                        }

                                        this.dataSource = column.dataSource
                                    }
                                }
                            }
                        }

                    }
                }
            }
        }
    }
}

external interface BlockProps : Props {
    var block: EmailTemplateBlock
    var rowIndex: Int
    var columnIndex: Int
    var blockIndex: Int
    var selectedElement: Triple<Int, Int, Int>
    var onClick: (Int, Int, Int) -> Unit
    var onChange: (EmailTemplateBlock) -> Unit
    var onDelete: () -> Unit
    var onMove: (Int, Int, Int, Int, Int, Int, EmailTemplateBlock, Boolean) -> Unit

    var dataSource: DataSource
//    var onDataSourceChanged: DataSource
}
val blockElement = fc<BlockProps> { props ->


    var itemId by useState("block_${props.rowIndex}_${props.columnIndex}_${props.blockIndex}")
    val blockRef = useRef(props.block)
    useEffect(props, props.block, props.rowIndex, props.columnIndex, props.blockIndex) {
        itemId = "block_${props.rowIndex}_${props.columnIndex}_${props.blockIndex}"
        blockRef.current = props.block
    }
    val (blockP, blockDrag, blockPreview) = useDrag<dynamic, dynamic, dynamic>({
        jso {
            type = "Block"
            item = jso {
                this.id = itemId
//                                                                                this.index = rowIndex

                this.block = props.block
                this.row = props.rowIndex
                this.column = props.columnIndex
                this.index = props.blockIndex
            }
            collect = {
                jso {
                    this.isDragging = it.isDragging()
                }
            }
            end = { itm, monitor ->
                val blockItem = blockRef.current ?: props.block //itm.block as EmailTemplateBlock
                val rowIdx = props.rowIndex //itm.row as Int
                val columnIdx = props.columnIndex//itm.column as Int
                val blockIdx = props.blockIndex//itm.index as Int

                val dropResult = monitor.getDropResult()
                if (dropResult != null) {
                    val isAbove = dropResult.isAbove as Boolean
                    val dropEffect = dropResult.dropEffect

                    val toRowIndex = dropResult.toRowIndex as Int
                    val toColumnIndex = dropResult.toColumnIndex as Int
                    val toBlockIndex = dropResult.toBlockIndex as Int

                    props.onMove(rowIdx, toRowIndex, columnIdx, toColumnIndex, blockIdx, if (isAbove) toBlockIndex else toBlockIndex+1, blockItem, dropEffect == "copy")
                }
            }
        }
    })

    var isSelected by useState(false)
    useEffect(props.selectedElement) {
        val result = props.selectedElement.first == props.rowIndex && props.selectedElement.second == props.columnIndex && props.selectedElement.third == props.blockIndex
        isSelected = result
    }

    var linkModal by useState(false)
    var linkValue by useState("")
    var variableModal by useState(false)
    var savedSelection by useState<dynamic>(Any())
    var savedRanges by useState(listOf<dynamic>())
    if (isSelected) {
        Modal {
            attrs.autoFocus = false
//            attrs.restoreFocus = true
            attrs.size = "lg"
            attrs.show = linkModal
            attrs.onHide = { linkModal = false }
//            attrs.onExited = {
//                val selection = window.asDynamic().getSelection()
//                selection.removeAllRanges()
//                savedRanges.forEach {
//                    println("$it ${it.startOffset} ${it.endOffset} ${it.collapsed}")
//                    selection.addRange(it)
//                }
//                savedRanges = listOf()
//            }
            ModalHeader {
                ModalTitle {
                    +"Введите URL ссылки"
                }
            }
            ModalBody {
                div("form-group row d-flex align-items-center mb-5") {
                    label("col-3 form-control-label") { +"Email получателя:" }
                    div("col-9") {
                        input(InputType.email, classes = "form-control") {
                            attrs.value = linkValue
                            attrs.onChangeFunction = {
                                it.preventDefault()
                                it.stopPropagation()
                                linkValue = (it.target as? HTMLInputElement)?.value.orEmpty()
                            }
                        }
                    }
                }
            }
            ModalFooter {
                Button {
                    attrs.variant = "secondary"
                    attrs.onClick = {
                        it.preventDefault()
                        it.stopPropagation()
                        linkModal = false

                        val selection = window.asDynamic().getSelection()
                        selection.removeAllRanges()
                        savedRanges.forEach {
                            selection.addRange(it)
                        }
                        savedRanges = listOf()
                        savedSelection = Any()
                    }
                    +"Отмена"
                }
                Button {
                    attrs.variant = "primary"
                    attrs.onClick = {
                        it.preventDefault()
                        it.stopPropagation()
                        linkModal = false

                        val selection = window.asDynamic().getSelection()
                        selection.removeAllRanges()
                        savedRanges.forEach {
                            selection.addRange(it)
                        }

//                        println(selection.toString())
//                        println(savedSelection.toString())
                        document.execCommand("insertHTML", false, "<a href=$linkValue style=\'text-decoration-line:none; color: unset;\'>$savedSelection</a>")
                        savedRanges = listOf()
                        savedSelection = Any()
//                        document.execCommand("createLink", false, linkValue)
//                        val linkElement = selection.anchorNode.parentNode
//                        linkElement.style.textDecoration = "none"
//                        linkElement.style.color = "unset"
                    }
                    +"Создать"
                }
            }
        }

        Modal {
            attrs.autoFocus = false
            attrs.size = "lg"
            attrs.show = variableModal
            attrs.onHide = {
                variableModal = false

                val selection = window.asDynamic().getSelection()
                selection.removeAllRanges()
                savedRanges.forEach {
                    selection.addRange(it)
                }
                savedRanges = listOf()
                savedSelection = Any()
            }
            ModalHeader {
                ModalTitle {
                    +"Выберите переменную для подстановки"
                }
            }
            ModalBody {

                fun RBuilder.renderVariableButton(title: String, variable: String) {
                    button(type = ButtonType.button, classes = "btn btn-primary m-1") {
                        attrs.onClickFunction = {
                            it.preventDefault()
                            it.stopPropagation()

                            variableModal = false

                            val selection = window.asDynamic().getSelection()
                            selection.removeAllRanges()
                            savedRanges.forEach {
                                selection.addRange(it)
                            }
                            savedRanges = listOf()
                            savedSelection = Any()

                            document.execCommand("insertText", false, "{{$variable}}")
                        }
                        +title
                    }
                }
                div("row d-flex align-items-center") {
                    div("col-4") {
                        when (props.dataSource) {
                            is DataSource.ProductsCategory -> {
                                h4("mt-2") { +"Переменные категории товара" }
                                renderVariableButton("Идентификатор", "data.id")
                                renderVariableButton("Наименование", "data.name")
                            }
                            is DataSource.Product -> {
                                h4("mt-2") { +"Переменные товара" }
                                renderVariableButton("Идентификатор", "data.id")
                                renderVariableButton("Наименование", "data.name")
                                renderVariableButton("В наличии", "data.available")
                                renderVariableButton("Ссылка", "data.url")
                                renderVariableButton("Изображение", "data.picture")
                                renderVariableButton("Цена", "data.price")
                                renderVariableButton("Прошлая цена", "data.old_price")
                                renderVariableButton("Категория", "data.category")
                                renderVariableButton("Описание", "data.description")
                                renderVariableButton("Производитель", "data.vendor")
                                renderVariableButton("Код производителя", "data.vendor_code")
                            }
                            DataSource.None -> h4("mt-2") { +"Не выбран источник данных" }
                            else -> {}
//                            DataSource.Store -> TODO
//                            DataSource.Subscriber -> TODO
//                            DataSource.EmailMessage -> TODO
//                            DataSource.Campaign -> TODO
                        }
                    }
                    div("col-4") {
                        h4("mt-2") { +"Подписчик" }
                        renderVariableButton("Идентификатор", "subscriber.id")
                        renderVariableButton("Идентификатор в магазине", "subscriber.store_id")
                        renderVariableButton("Имя", "subscriber.name")
                        renderVariableButton("Дата регистрации", "subscriber.registration_date")
                        renderVariableButton("Email", "subscriber.email")
                        renderVariableButton("Телефон", "subscriber.phone")
                        renderVariableButton("Описание", "subscriber.description")

                        h4("mt-2") { +"Магазин" }
                        renderVariableButton("Название магазина", "store.name")
                        renderVariableButton("Ссылка на магазин", "store.url")
                    }
                    div("col-4") {

                        h4("mt-2") { +"Email-сообщение" }
                        renderVariableButton("Дата отправки", "email.date")
                        renderVariableButton("Время отправки", "email.time")

                        h4("mt-2") { +"Кампания рассылки" }
                        renderVariableButton("Идентификатор", "campaign.id")
                        renderVariableButton("Тема", "campaign.subject")
                        renderVariableButton("UTM-campaign", "campaign.utm_campaign")
                        renderVariableButton("UTM-medium", "campaign.utm_medium")
                        renderVariableButton("UTM-source", "campaign.utm_source")
                    }
                }
            }
            ModalFooter {
                Button {
                    attrs.variant = "secondary"
                    attrs.onClick = {
                        it.preventDefault()
                        it.stopPropagation()
                        variableModal = false

                        val selection = window.asDynamic().getSelection()
                        selection.removeAllRanges()
                        savedRanges.forEach {
                            selection.addRange(it)
                        }
                        savedRanges = listOf()
                        savedSelection = Any()
                    }
                    +"Отмена"
                }
            }
        }
    }

    var showEmojiPopup by useState(false)
    Modal {
        attrs.autoFocus = false
        attrs.show = showEmojiPopup
        attrs.onHide = {
            showEmojiPopup = false

            val selection = window.asDynamic().getSelection()
            selection.removeAllRanges()
            savedRanges.forEach {
                selection.addRange(it)
            }
            savedRanges = listOf()
            savedSelection = Any()
        }
        ModalHeader {
            ModalTitle {
                +"Выберите Emoji для подстановки"
            }
        }
        ModalBody {
            EmojiPicker {
                attrs.autoFocusSearch = false
                attrs.searchDisabled = true
                attrs.onEmojiClick = {

                    variableModal = false

                    val selection = window.asDynamic().getSelection()
                    selection.removeAllRanges()
                    savedRanges.forEach {
                        selection.addRange(it)
                    }
                    savedRanges = listOf()
                    savedSelection = Any()

                    document.execCommand("insertText", false, "${it.emoji}")

                    showEmojiPopup = false
                }
            }
        }
        ModalFooter {
            Button {
                attrs.variant = "secondary"
                attrs.onClick = {
                    it.preventDefault()
                    it.stopPropagation()
                    variableModal = false

                    val selection = window.asDynamic().getSelection()
                    selection.removeAllRanges()
                    savedRanges.forEach {
                        selection.addRange(it)
                    }
                    savedRanges = listOf()
                    savedSelection = Any()
                }
                +"Отмена"
            }
        }
    }

    var hasSelection by useState(false)
    useEffect(document, isSelected) {
        if (isSelected) {
            val listener: ((Event) -> Unit) = { _ ->
                hasSelection = (props.block is EmailTemplateBlock.Header
                        || props.block is EmailTemplateBlock.Paragraph
                        || props.block is EmailTemplateBlock.List
                        || props.block is EmailTemplateBlock.Button)
                        && window.asDynamic().getSelection().type != "None"
//                hasSelection = (window.asDynamic().getSelection().toString() as? String)?.isNotBlank() == true
            }
            document.addEventListener("selectionchange", listener)
            cleanup { document.removeEventListener("selectionchange", listener) }
        }
    }
//    useEffect(divRef.current) {
//        divRef.current?.let { d ->
//            val sel = window.asDynamic().getSelection()
//        }
//    }
    styledDiv {
        attrs.onClickFunction = {
            if (props.selectedElement.first != props.rowIndex || props.selectedElement.second != props.columnIndex || props.selectedElement.third != props.blockIndex) {
                props.onClick(props.rowIndex, props.columnIndex, props.blockIndex)
                it.stopPropagation()
                it.preventDefault()
            }
        }
        css {
            width = 100.pct
            boxSizing = BoxSizing.contentBox
            position = Position.relative

            "textarea:focus, input:focus, *:focus" {
                outline = Outline.none
                boxShadow = BoxShadows.none
            }
            if (props.selectedElement.first == props.rowIndex && props.selectedElement.second == props.columnIndex && props.selectedElement.third == props.blockIndex) {
//                                                                            zIndex = 50
                boxShadow(Color("#17a2b8"), spreadRadius = 2.px)
                ".blockTitle" {
                    display = Display.block
                }
                ".blockMove" {
                    display = Display.block
                }
                ".blockDelete" {
                    display = Display.block
                }
                hover {
                    backgroundColor = Color("#17a2b8").withAlpha(0.125)
                }
            } else {

                hover {
                    zIndex = 50
                    boxShadow(Color("#17a2b8"), spreadRadius = 2.px)
                    backgroundColor = Color("#17a2b8").withAlpha(0.125)
                    ".blockTitle" {
                        display = Display.block
                    }
                    ".blockMove" {
                        display = Display.block
                    }
                }
            }
        }

        Drop {
            attrs {
                type = "Block"
                row = props.rowIndex
                column = props.columnIndex
                block = props.blockIndex
                onDrop = { itm, isAbove ->
                    val blockItem = itm.block as EmailTemplateBlock
                    val rowIdx = itm.row as Int
                    val columnIdx = itm.column as Int
                    val blockIdx = itm.index as Int

                    props.onMove(rowIdx, props.rowIndex, columnIdx, props.columnIndex, blockIdx, if (isAbove) props.blockIndex else props.blockIndex+1, blockItem, false)
                }
            }
        }
//        renderDrop("Block", props.rowIndex, props.columnIndex, props.blockIndex) { itm, isAbove ->

//                                                                            val blockItem = itm.block as EmailTemplateBlock
//                                                                            val rowIdx = itm.row as Int
//                                                                            val columnIdx = itm.column as Int
//                                                                            val blockIdx = itm.index as Int
//
//
//                                                                            moveBlock(rowIdx, rowIndex, columnIdx, columnIndex, blockIdx, if (isAbove) blockIndex else blockIndex+1, blockItem)
//                                                                            moveBlock(rowIdx, columnIdx, blockIdx, blockItem)
//        }

        styledDiv {
            styledDiv {
                css {
                    classes.add("blockTitle")
                    position = Position.absolute
                    bottom = (-26).px
                    right = (-2).px
                    backgroundColor = Color("#17a2b8")
                    border(2.px, BorderStyle.solid, Color("#17a2b8"))
                    borderTopLeftRadius = 0.px
                    borderTopRightRadius = 0.px
                    borderBottomLeftRadius = 4.px
                    borderBottomRightRadius = 4.px
                    color = Color.white
                    display = Display.none
                }
                +when(props.block) {
                    is EmailTemplateBlock.Header -> "Заголовок"
                    is EmailTemplateBlock.Paragraph -> "Параграф"
                    is EmailTemplateBlock.List -> "Список"
                    is EmailTemplateBlock.Image -> "Картинка"
                    is EmailTemplateBlock.Video -> "Видео"
                    is EmailTemplateBlock.Button -> "Кнопка"
                    is EmailTemplateBlock.Separator -> "Разделитель"
                    is EmailTemplateBlock.Spacer -> "Спейсер"
                    is EmailTemplateBlock.Text -> "Текст"
                    is EmailTemplateBlock.Html -> "HTML/Таблицы"
                }
            }
            styledDiv {
                ref = blockDrag
                css {
                    classes.add("blockMove")
                    position = Position.absolute
                    top = LinearDimension("calc(50% - 15px)")
                    right = (-32).px
                    backgroundColor = Color("#17a2b8")
                    border(4.px, BorderStyle.solid, Color("#17a2b8"))
                    borderTopLeftRadius = 0.px
                    borderTopRightRadius = 8.px
                    borderBottomLeftRadius = 0.px
                    borderBottomRightRadius = 8.px
                    display = Display.none
                    cursor = Cursor.move
                    zIndex = 20
                }
                styledI {
                    css {
                        classes.add("la la-arrows-v")
                        color = Color.white
                        padding(5.px)
                        cursor = Cursor.move
                        pointerEvents = PointerEvents.none
                    }
                }
            }
            styledDiv {
                attrs.onClickFunction = {
                    props.onDelete()
                }
                css {
                    classes.add("blockDelete")
                    position = Position.absolute
                    top = LinearDimension("calc(50% - 15px)")
                    right = LinearDimension("-72px")
                    backgroundColor = Color("#17a2b8")
                    border(4.px, BorderStyle.solid, Color("#17a2b8"))
                    borderRadius = 8.px
                    display = Display.none
                    cursor = Cursor.pointer
                    zIndex = 20
                }
                styledI {
                    css {
                        classes.add("la la-trash")
                        color = Color.white
                        padding(5.px)
                        cursor = Cursor.move
                        pointerEvents = PointerEvents.none
                    }
                }
            }
            styledDiv {
                styledDiv {
                    css {
                        position = Position.absolute
                        right = 0.px
                        left = 0.px
                        pointerEvents = PointerEvents.none
                    }

                    if (isSelected && hasSelection) {
                        styledDiv {
                            css {
                                classes.add("widget has-shadow")
                                backgroundColor = Color("#5d5386").withAlpha(0.9)
                                borderRadius = 12.px
//                                border(4.px, BorderStyle.solid, Color("#5d5386"), 6.px)
                                position = Position.relative
                                zIndex = 1000
                                top = (-65).px
                                marginLeft = 50.pct
                                transform {
                                    translateX((-50).pct)
                                }
                                width = LinearDimension.maxContent
                            }

                            fun RBuilder.renderButton(icon: String, ml: Int = 4, mr: Int = 4, onClick: () -> Unit) {
                                styledDiv {
                                    attrs.onMouseDownFunction = {
//                                    attrs.onClickFunction = {
                                        it.preventDefault()
                                        it.stopPropagation()
                                        onClick()
                                    }
                                    css {
                                        height = 30.px
                                        width = 30.px
                                        color = Color.white
//                                        backgroundColor = Color("#5d5386")
                                        border(1.px, BorderStyle.solid, Color.white)
                                        borderRadius = 15.px
                                        textAlign = TextAlign.center
                                        verticalAlign = VerticalAlign.middle
                                        fontSize = 20.px
                                        padding(8.px)
                                        marginLeft = ml.px
                                        marginRight = mr.px
                                        hover {
                                            backgroundColor = Color.white
                                            color = Color("#5d5386")
                                        }
                                        transition("all", 0.25.s, Timing.ease, 0.s)
                                    }
                                    i(icon) {
                                        attrs.jsStyle {
                                            pointerEvents = "none"
                                            verticalAlign = "top"
                                            marginTop = "-4px"
                                            marginLeft = "-4px"
                                        }
                                    }

                                }
                            }

                            styledDiv {
                                css {
                                    classes.add("row d-flex pt-2 pb-2 pl-4 pr-4")
                                    pointerEvents = PointerEvents.auto
                                }

                                renderButton("la la-bold") { document.execCommand("bold", false, "") }
                                renderButton("la la-italic", mr = 12) { document.execCommand("italic", false, "") }
                                renderButton("la la-underline") { document.execCommand("underline", false, "") }
                                renderButton("la la-strikethrough", mr = 12) { document.execCommand("strikeThrough", false, "") }
                                renderButton("la la-subscript") { document.execCommand("subscript", false, "") }
                                renderButton("la la-superscript", mr = 12) { document.execCommand("superscript", false, "") }
                                renderButton("la la-link") {
                                    val selection = window.asDynamic().getSelection()
//                                    val ranges = mutableListOf<dynamic>()
//                                    for (i in 0 until selection.rangeCount as Int) {
//                                        ranges.add(selection.getRangeAt(i))
//                                    }
//                                    savedRanges = ranges
//                                    savedSelection = selection
//
//                                    linkModal = true

                                    window.prompt("Создание ссылки", "https://")?.let { url ->
                                        val color = when (val block = props.block) {
                                            is EmailTemplateBlock.Header -> block.linkColor
                                            is EmailTemplateBlock.Paragraph -> block.linkColor
                                            is EmailTemplateBlock.List -> block.linkColor
                                            is EmailTemplateBlock.Text -> block.linkColor
                                            else -> "unset"
                                        }
                                        document.execCommand("insertHTML", false, "<a href=$url style=\'text-decoration-line:none; color: $color;\'>$selection</a>")
                                    }
                                }
                                renderButton("la la-unlink", mr = 12) { document.execCommand("unlink", false, "") }

                                styledDiv {
                                    attrs.onMouseDownFunction = {
                                        it.preventDefault()
                                        it.stopPropagation()


                                        val selection = window.asDynamic().getSelection()
                                        val ranges = mutableListOf<dynamic>()
                                        for (i in 0 until selection.rangeCount as Int) {
                                            ranges.add(selection.getRangeAt(i))
                                        }
                                        savedRanges = ranges
                                        savedSelection = selection
                                        showEmojiPopup = true
                                    }
                                    css {
                                        height = 30.px
                                        width = 30.px
                                        color = Color.white
//                                        backgroundColor = Color("#5d5386")
                                        border(1.px, BorderStyle.solid, Color.white)
                                        borderRadius = 15.px
                                        textAlign = TextAlign.center
                                        verticalAlign = VerticalAlign.middle
                                        fontSize = 20.px
                                        padding(0.px)
                                        marginLeft = 4.px
                                        marginRight = 12.px
                                        hover {
                                            backgroundColor = Color.white
                                            color = Color("#5d5386")
                                        }
                                        cursor = Cursor.pointer
                                        transition("all", 0.25.s, Timing.ease, 0.s)
                                    }
                                    +"\uD83D\uDE0A"
                                }

                                styledDiv {
                                    attrs.onMouseDownFunction = {
                                        it.preventDefault()
                                        it.stopPropagation()

                                        val selection = window.asDynamic().getSelection()
                                        val ranges = mutableListOf<dynamic>()
                                        for (i in 0 until selection.rangeCount as Int) {
                                            ranges.add(selection.getRangeAt(i))
                                        }
                                        savedRanges = ranges
                                        savedSelection = selection
                                        variableModal = true

//                                        onClick()
                                    }
                                    css {
                                        height = 30.px
                                        color = Color.white
//                                        backgroundColor = Color("#5d5386")
                                        border(1.px, BorderStyle.solid, Color.white)
                                        borderRadius = 20.px
                                        textAlign = TextAlign.center
                                        verticalAlign = VerticalAlign.middle
                                        padding(8.px)
                                        marginLeft = 4.px
                                        marginRight = 4.px
                                        hover {
                                            backgroundColor = Color.white
                                            color = Color("#5d5386")
                                        }
                                        transition("all", 0.25.s, Timing.ease, 0.s)
                                    }
                                    span {
                                        attrs.jsStyle {
                                            marginTop = "-4px"
                                            verticalAlign = "top"
                                            pointerEvents = "none"
                                        }
                                        +"Добавить переменную"
                                    }
                                    i("la la-angle-down") {
                                        attrs.jsStyle {
                                            fontSize = "16px"
                                            pointerEvents = "none"
                                            verticalAlign = "top"
                                            marginTop = "-2px"
                                            marginLeft = "4px"
                                        }
                                    }

                                }


                                renderButton("la la-eraser") { document.execCommand("removeFormat", false, "") }



//                                button(type = web.html.ButtonType.button, classes = "btn btn-outline-primary ml-1 mr-1") {
//                                    attrs.onClickFunction = {
//                                        it.preventDefault()
//                                        it.stopPropagation()
//
//                                        var fontElements = window.asDynamic().getSelection().anchorNode.parentNode
//                                        println("current size: ${fontElements.style.fontSize}")
//                                        val currentSize = (fontElements.style.fontSize as? String)?.let { (it.toIntOrNull() ?: 12) + 2 } ?: 14
//                                        document.execCommand("styleWithCss", true, "")
//                                        document.execCommand("fontSize", false, "7")
//                                        fontElements = window.asDynamic().getSelection().anchorNode.parentNode
//                                        fontElements.removeAttribute("size");
//                                        fontElements.style.fontSize = "${currentSize}px";
//                                        document.execCommand("styleWithCss", false, "")
////                                        it.stopImmediatePropagation()
//                                    }
//                                    i("la la-superscript") {}
//                                }

//                                val fontSizez = listOf(
//                                    8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 48, 64
//                                )
//                                child(dropdownSelect) {
//                                    attrs {
//                                        dropdownOpenDefault = false
//                                        multiSelect = false
//                                        showFilter = true
//                                        currentValue = mapOf("12" to "12px")
//                                        selectValues = fontSizez.map { it.toString() to "${it}px" }
//                                        onSave = {
//                                            document.execCommand("styleWithCss", true, "")
//                                            document.execCommand("fontSize", false, "7")
//                                            val fontElements = window.asDynamic().getSelection().anchorNode.parentNode
//                                            fontElements.removeAttribute("size");
//                                            fontElements.style.fontSize = "${(it.keys.firstOrNull() ?: "12")}px"
//                                            document.execCommand("styleWithCss", false, "")
////                                            saveDialogSelectedCampaign = it.keys.firstOrNull().orEmpty()
//                                        }
//                                    }
//                                }

                            }
                        }
                    }
                }
                css {
                    put("all", "none")
                    put("list-style", "unset")
                    put("list-style-position", "inside")
                    child("*") {
                        put("all", "none")
                        put("list-style", "unset")
                        put("list-style-position", "inside")
                    }
                    child("ol, ul, li") {
                        put("list-style", "unset")
                        put("list-style-position", "inside")
                    }
                    children {
                        put("all", "none")
                        put("list-style", "unset")
                        put("list-style-position", "inside")
                    }
                }
                attrs.jsStyle {
                    all = "none"
                    this["*"] = jso {
                        all = "none"
                    }
                    this["> *"] = jso {
                        all = "none"
                    }
                }
                ref = blockPreview



//                val text = useRef("")
                var text by useState("")
                useEffect(props.block, isSelected) {

                    text = if (isSelected) {
                        props.block.getBlockTextValue()
                    } else {
                        props.block.renderDefaultPreview()
                    }
                    if (!isSelected) {
                        props.block.let { block ->
                            if (block is EmailTemplateBlock.Html) {
                                Http.post("/templates/preview-block", block.content, { }) { response ->
                                    if (response.status == HttpStatusCode.OK) {
                                        text = response.body()
                                    }
                                }
                            }
                        }
                    }
                }

//                when(val block = props.block) {
//                    is EmailTemplateBlock.Header -> {
//                        tag({
//                            attrs.jsStyle {
//                                block.font?.let {
//                                    fontFamily = it
//                                }
//                                fontWeight = if (block.isBold) 700 else 400
//                                color = block.fontColor
//                                textAlign = block.align
//                                direction = if (block.rtlTextDirection) "rtl" else "ltr"
//                                lineHeight = "${block.lineHeight}%"
//                                letterSpacing = "${block.symbolsInterval}px"
//                                if (block.generalSettings.margin != null) {
//                                    padding = block.generalSettings.margin
//                                } else {
//                                    paddingLeft = block.generalSettings.margins[0]
//                                    paddingTop = block.generalSettings.margins[1]
//                                    paddingRight = block.generalSettings.margins[2]
//                                    paddingBottom = block.generalSettings.margins[3]
//                                }
//                            }
//                            attrs["contentEditable"] = true
//                            attrs["onInput"] = { e: Event ->
//                                (e.target as? HTMLHeadingElement)?.innerHTML?.let { content ->
//                                    block.content = content
////                                    text = content
////                                    text.current = content
//                                }
//                            }
//                            attrs["onBlur"] = { e: Event ->
//                                (e.target as? HTMLHeadingElement)?.innerHTML?.let { text ->
//                                    if (block.content != text) {
//                                        val value = sanitizeHtml(
//                                            block.content,
//                                            jso {
//                                                allowedTags = arrayOf("b", "i", "u", "strike", "sub", "sup", "a", "br", "div")
//                                            }
//                                        )
//                                        props.onChange(block.copy(content = value))
//                                    }
//                                }
//                            }
//                            domProps.dangerouslySetInnerHTML = jso {
//                                this.__html = block.content// text//text.current.orEmpty()
//                            }
//                        }) {
//                            HTMLTag("h${block.type}", it, mapOf(), null, false, false)
//                        }
//                    }
//                    is EmailTemplateBlock.Paragraph -> {
//                        styledP {
//                            css {
//                                rule("a") {
//                                    color = Color(block.linkColor)
//                                }
//                            }
//                            attrs.jsStyle {
//                                block.font?.let {
//                                    fontFamily = it
////                            this["font-family"] = it
//                                }
//                                margin = "0px"
//                                fontWeight = if (block.isBold) 700 else 400
//                                fontSize = "${block.fontSize}px"
//                                color = block.fontColor
//                                textAlign = block.align
//                                direction = if (block.rtlTextDirection) "rtl" else "ltr"
//                                lineHeight = "${block.lineHeight}%"
//                                letterSpacing = "${block.symbolsInterval}px"
//                                if (block.generalSettings.margin != null) {
//                                    padding = block.generalSettings.margin
//                                } else {
//                                    paddingLeft = block.generalSettings.margins[0]
//                                    paddingTop = block.generalSettings.margins[1]
//                                    paddingRight = block.generalSettings.margins[2]
//                                    paddingBottom = block.generalSettings.margins[3]
//                                }
//                            }
//                            attrs.contentEditable = true
//                            attrs["onInput"] = { e: Event ->
//                                (e.target as? HTMLParagraphElement)?.innerHTML?.let { content ->
//                                    block.content = content
////                                    text = content
//                                }
//                            }
//                            attrs["onBlur"] = { e: Event ->
//                                if (block.content != text) {
//                                    val value = sanitizeHtml(
//                                        block.content,
//                                        jso {
//                                            allowedTags = arrayOf("b", "i", "u", "strike", "sub", "sup", "a", "br", "div")
//                                        }
//                                    )
//                                    props.onChange(block.copy(content = value))
//                                }
//                            }
//                            domProps.dangerouslySetInnerHTML = jso { this.__html = text }
//                        }
//                    }
//                    is EmailTemplateBlock.List -> {
//                        if (block.unorderedStyle) {
//                            ul {
//                                attrs.jsStyle {
//                                    block.font?.let {
//                                        this["font-family"] = it
//                                    }
//                                    fontWeight = if (block.isBold) 700 else 400
//                                    fontSize = "${block.fontSize}px"
//                                    color = block.fontColor
//                                    textAlign = block.align
//                                    direction = if (block.rtlTextDirection) "rtl" else "ltr"
//                                    lineHeight = "${block.lineHeight}%"
//                                    letterSpacing = "${block.symbolsInterval}px"
//                                    if (block.generalSettings.margin != null) {
//                                        padding = block.generalSettings.margin
//                                    } else {
//                                        paddingLeft = block.generalSettings.margins[0]
//                                        paddingTop = block.generalSettings.margins[1]
//                                        paddingRight = block.generalSettings.margins[2]
//                                        paddingBottom = block.generalSettings.margins[3]
//                                    }
//                                }
//                                attrs.contentEditable = true
//                                attrs.onInputFunction = {
//                                    (it.target as? HTMLUListElement)?.innerHTML?.let { content ->
//                                        block.content = content
////                                var resultContent = if (content.contains("\n")) {
////                                    content.replace("\n","</li><li>")
////                                } else {
////                                    content
////                                }
////                                if (!resultContent.endsWith("</li>")) {
////                                    resultContent += "</li>"
////                                }
////                                if (!resultContent.startsWith("<li>")) {
////                                    resultContent = "<li>$resultContent"
////                                }
////                                        text = content
//                                    }
//                                }
//                                attrs["onBlur"] = { e: Event ->
//                                    if (block.content != text) {
//                                        val value = sanitizeHtml(
//                                            block.content,
//                                            jso {
//                                                allowedTags = arrayOf("b", "i", "u", "strike", "sub", "sup", "a", "br", "div", "li", "ul")
//                                            }
//                                        )
//                                        props.onChange(block.copy(content = value))
//                                    }
//                                }
////                                attrs.onBlurFunction = {
////                                    if (block.content != text) {
////                                        props.onChange(block.copy(content = text))
////                                    }
////                                }
//                                domProps.dangerouslySetInnerHTML = jso { __html = text }
//                            }
//                        } else {
//                            ol {
//                                attrs.jsStyle {
//                                    block.font?.let {
//                                        this["font-family"] = it
//                                    }
//                                    fontWeight = if (block.isBold) 700 else 400
//                                    fontSize = "${block.fontSize}px"
//                                    color = block.fontColor
//                                    textAlign = block.align
//                                    direction = if (block.rtlTextDirection) "rtl" else "ltr"
//                                    lineHeight = "${block.lineHeight}%"
//                                    letterSpacing = "${block.symbolsInterval}px"
//                                    listStyleType = "decimal"
//                                    if (block.generalSettings.margin != null) {
//                                        padding = block.generalSettings.margin
//                                    } else {
//                                        paddingLeft = block.generalSettings.margins[0]
//                                        paddingTop = block.generalSettings.margins[1]
//                                        paddingRight = block.generalSettings.margins[2]
//                                        paddingBottom = block.generalSettings.margins[3]
//                                    }
//                                }
//                                attrs.contentEditable = true
//                                attrs.onInputFunction = {
//                                    (it.target as? HTMLOListElement)?.innerHTML?.let { content ->
////                                        text = content
//                                        block.content = content
//                                    }
//                                }
//                                attrs["onBlur"] = { e: Event ->
//                                    if (block.content != text) {
//                                        val value = sanitizeHtml(
//                                            block.content,
//                                            jso {
//                                                allowedTags = arrayOf("b", "i", "u", "strike", "sub", "sup", "a", "br", "div", "li", "ol")
//                                            }
//                                        )
//                                        props.onChange(block.copy(content = value))
//                                    }
//                                }
////                                attrs.onBlurFunction = {
////                                    if (block.content != text) {
////                                        props.onChange(block.copy(content = text))
////                                    }
////                                }
//                                domProps.dangerouslySetInnerHTML = jso { __html = text }
//                            }
//                        }
//                    }
//                    is EmailTemplateBlock.Image -> {
//                        styledImg {
//                            css {
//                                if (block.src.isBlank()) {
//                                    minWidth = 100.px
//                                    minHeight = 50.px
//                                }
//                                maxWidth = 100.pct
//                            }
//                            attrs.alt = block.alt
//                            attrs.src = block.src
//                            attrs.jsStyle {
//                                if (block.generalSettings.margin != null) {
//                                    padding = block.generalSettings.margin
//                                } else {
//                                    paddingLeft = block.generalSettings.margins[0]
//                                    paddingTop = block.generalSettings.margins[1]
//                                    paddingRight = block.generalSettings.margins[2]
//                                    paddingBottom = block.generalSettings.margins[3]
//                                }
//                            }
//                        }
//                    }
//                    is EmailTemplateBlock.Video -> {
//                        styledImg {
//                            css {
//                                if (block.src.isBlank()) {
//                                    minWidth = 100.px
//                                    minHeight = 50.px
//                                }
//                                maxWidth = 100.pct
//                            }
//                            attrs.alt = block.title
//                            attrs.src = block.src
//                        }
//                        styledDiv {
//                            css {
//                                position = Position.absolute
//                                whiteSpace = WhiteSpace.nowrap
//                                verticalAlign = VerticalAlign.middle
//                                textAlign = TextAlign.left
//                                lineHeight = LineHeight("100% !important")
//                                left = 50.pct
//                                top = LinearDimension("0")
//                                bottom = LinearDimension("0")
//                            }
//                            styledDiv {
//                                css {
//                                    height = 100.pct
//                                    display = Display.inlineBlock
//                                    verticalAlign = VerticalAlign.middle
//                                }
//                            }
//                            img(src = "/assets/img/video_thumbs/${block.icon}.png") {
//                                attrs.jsStyle {
//                                    width = "${block.iconSize}px"
//                                    height = "${block.iconSize}px"
//                                    marginLeft = "-50%"
//                                }
//                            }
//                        }
//                    }
//                    is EmailTemplateBlock.Button -> {
//                        styledDiv {
//                            css {
//                                minHeight = 10.px
//                                textAlign = TextAlign.valueOf(block.align)
//
//                                if (block.generalSettings.margin != null) {
//                                    padding(block.generalSettings.margin!!.px)
//                                } else {
//                                    paddingLeft = block.generalSettings.margins[0].px
//                                    paddingTop = block.generalSettings.margins[1].px
//                                    paddingRight = block.generalSettings.margins[2].px
//                                    paddingBottom = block.generalSettings.margins[3].px
//                                }
//                            }
//                            attrs["align"] = "center"
////                    +"""<!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" style="height:38px;width:85px;v-text-anchor:middle;" arcsize="11%" stroke="false" fillcolor="#3AAEE0"><w:anchorlock/><v:textbox inset="0px,0px,0px,0px"><center style="color:#ffffff; font-family:Arial, sans-serif; font-size:14px"><![endif]-->"""
//                            styledDiv {
//                                css {
//                                    textDecoration = TextDecoration.none
//                                    display = Display.inlineBlock
//                                    setCustomProperty("mso-border-alt", object : CssValue("none") {})
//                                    wordBreak = WordBreak.keepAll
//                                    block.font?.let {
//                                        fontFamily = it
//                                    }
//                                    fontWeight = if (block.isBold) FontWeight.w700 else FontWeight.w400
//                                    fontSize = block.fontSize.px
//                                    color = Color(block.fontColor)
////                                    textAlign = TextAlign.valueOf(block.align)
//                                    lineHeight = LineHeight("${block.lineHeight}%")
//                                    letterSpacing = block.symbolsInterval.px
//                                    borderRadius = block.cornersRadius.px
//
//                                    backgroundColor = Color(block.backgroundColor)
//
//                                    block.borders[0].let { borderLeft(it.size.px, BorderStyle.valueOf(it.type), Color(it.color)) }
//                                    block.borders[1].let { borderTop(it.size.px, BorderStyle.valueOf(it.type), Color(it.color)) }
//                                    block.borders[2].let { borderRight(it.size.px, BorderStyle.valueOf(it.type), Color(it.color)) }
//                                    block.borders[3].let { borderBottom(it.size.px, BorderStyle.valueOf(it.type), Color(it.color)) }
//
//                                    paddingLeft = block.paddings[0].px
//                                    paddingTop = block.paddings[1].px
//                                    paddingRight = block.paddings[2].px
//                                    paddingBottom = block.paddings[3].px
//                                }
//                                styledSpan {
//                                    attrs.contentEditable = true
//                                    attrs.onInputFunction = {
//                                        (it.target as? HTMLSpanElement)?.innerHTML?.let { content ->
//                                            block.title = content
////                                            text = content
//                                        }
//                                    }
//                                    attrs["onBlur"] = { e: Event ->
//                                        if (block.title != text) {
//                                            val value = sanitizeHtml(
//                                                block.title,
//                                                jso {
//                                                    allowedTags = arrayOf("b", "i", "u", "strike", "sub", "sup", "a", "br", "div")
//                                                }
//                                            )
//                                            props.onChange(block.copy(title = value))
//                                        }
//                                    }
////                                    attrs.onBlurFunction = {
////                                        if (block.title != text) {
////                                            props.onChange(block.copy(title = text))
////                                        }
////                                    }
//                                    domProps.dangerouslySetInnerHTML = jso { __html = text }
//                                }
//                            }
//                        }
//                    }
//                    is EmailTemplateBlock.Separator -> {
//                        styledDiv {
//                            css {
//                                minHeight = 5.px
//                                padding(10.px)
//                                lineHeight = LineHeight("0")
//                                textAlign = TextAlign.valueOf(block.align)
//                            }
//                            styledDiv {
//                                css {
//                                    minHeight = 1.px
//                                    display = Display.inlineBlock
//                                    borderTopWidth = block.height.px
//                                    borderTopStyle = BorderStyle.valueOf(block.type)
//                                    borderTopColor = Color(block.color)
//                                    width = block.width.pct
//                                    height = 1.px
//                                }
//                            }
//                        }
//                    }
//                    is EmailTemplateBlock.Spacer -> {
//                        styledDiv {
//                            css {
//                                minHeight = 5.px
//                                height = block.height.px
//                            }
//                        }
//                    }
//                    is EmailTemplateBlock.Text -> {
//                        div {
//                            attrs.contentEditable = true
//                            attrs.onInputFunction = {
//                                (it.target as? HTMLDivElement)?.innerHTML?.let { content ->
//                                    block.content = content
//                                }
//                            }
//                            attrs["onBlur"] = { e: Event ->
//                                if (block.content != text) {
//                                    val value = sanitizeHtml(
//                                        block.content,
//                                        jso {
//                                            allowedTags = arrayOf("b", "i", "u", "strike", "sub", "sup", "a", "br", "div")
//                                        }
//                                    )
//                                    props.onChange(block.copy(content = value))
//                                }
//                            }
////                            attrs.onBlurFunction = {
////                                if (block.content != text) {
////                                    props.onChange(block.copy(content = text))
////                                }
////                            }
//                            domProps.dangerouslySetInnerHTML = jso { __html = text }
//                        }
//                    }
//                    is EmailTemplateBlock.Html -> {
//                        div {
////                            attrs.contentEditable = true
////                            attrs.onInputFunction = {
////                                (it.target as? HTMLDivElement)?.innerHTML?.let { content ->
////                                    text.current = content
////                                }
////                            }
////                            attrs.onBlurFunction = {
////                                if (block.content != text.current) {
////                                    props.onChange(block.copy(content = text.current.orEmpty()))
////                                }
////                            }
////                            println("Html: ${text == block.content}")
////                            println("Html: $text")
////                            println("Html: ${block.content}")
////                            +text
//                            domProps.dangerouslySetInnerHTML = jso { __html = text }
//                        }
//                    }
//                }

//                renderBlock(
//                    props.block,
//                    isSelected
////                                                                            { isFocused ->
////                                                                                println("$rowIndex, $columnIndex, $blockIndex : $isFocused")
////                                                                                if (isFocused) {
////                                                                                    selectedElement = Triple(rowIndex, columnIndex, blockIndex)
////                                                                                } else if (selectedElement?.first == rowIndex && selectedElement?.second == columnIndex && selectedElement?.third == blockIndex) {
////                                                                                    selectedElement = null
////                                                                                }
////                                                                            }
//                ) { newBlock ->
////                                                    val blocks = column.blocks.toMutableList()
////                                                    blocks[blockIndex] = newBlock
////                                                    val columns = row.columns.toMutableList()
////                                                    columns[columnIndex] = column.copy(blocks = blocks.toList())
////                                                    val rowsResult = rows.toMutableList()
////                                                    rowsResult[rowIndex] = row.copy(columns = columns.toList())
////                                                    rows = rowsResult.toTypedArray()
////                                                    println(rowsResult)
//                }
            }

//                                                                        +block.toString()
        }
    }
}

private external interface BlockButtonProps : Props {
    var block: EmailTemplateBlock
    var icon: String
    var title: String
    var onMove: (Int, Int, Int, Int, Int, Int, EmailTemplateBlock, Boolean) -> Unit
}
private val BlockButton = fc<BlockButtonProps> { props ->
    val (dragProps, drag, _) = useDrag<dynamic, dynamic, dynamic>({
        jso {
            type = "Block"
            item = jso {
                this.row = -1
                this.column = -1
                this.block = props.block
                this.index = -1
            }
            end = { itm, monitor ->
                val blockItem = itm.block as EmailTemplateBlock
                val rowIdx = itm.row as Int
                val columnIdx = itm.column as Int
                val blockIdx = itm.index as Int

                val dropResult = monitor.getDropResult()
                if (dropResult != null) {
                    val isAbove = dropResult.isAbove as Boolean
                    val dropEffect = dropResult.dropEffect

                    val toRowIndex = dropResult.toRowIndex as Int
                    val toColumnIndex = dropResult.toColumnIndex as Int
                    val toBlockIndex = dropResult.toBlockIndex as Int

                    props.onMove(rowIdx, toRowIndex, columnIdx, toColumnIndex, blockIdx, if (isAbove) toBlockIndex else toBlockIndex+1, blockItem, dropEffect == "copy")
                }
            }
        }
    })
    div("p-2 col-4") {
        styledDiv {
            ref = drag
            css {
                classes.add("widget has-shadow")
                marginBottom = 0.px
                height = 100.px

                padding(20.px, 8.px)
                cursor = Cursor.move
                textAlign = TextAlign.center
                color = Color("#5d5386")
            }

            styledI {
                css {
                    classes.add(props.icon)
                    fontSize = 2.rem
                    color = Color("#5d5386")
                    display = Display.block
                    padding(5.px)
                }
            }
            +props.title
        }
    }
}

private external interface RowButtonProps : Props {
    var name: String
    var columns: List<Int>
    var onMoveRow: (dynamic, Int, Int, Boolean, Boolean) -> Unit
    var onDelete: () -> Unit
}
private val RowButton = fc<RowButtonProps> { props ->
    val (dragProps, drag, _) = useDrag<dynamic, dynamic, dynamic>({
        jso {
            type = "Row"
            item = jso {
                this.id = "row_new"
                this.index = -1
                this.columns = props.columns.toTypedArray()
            }
            end = { itm, monitor ->

                val dropResult = monitor.getDropResult()

                if (dropResult != null) {
                    val fromRowIndex = itm.index as Int
                    val isAbove = dropResult.isAbove as Boolean
                    val toRowIndex = dropResult.toRowIndex as Int
                    val dropEffect = dropResult.dropEffect

                    props.onMoveRow(itm, fromRowIndex, toRowIndex, isAbove, dropEffect == "copy")
                }
            }
        }
    })
    styledDiv {
        ref = drag
        css {
            classes.add("form-group row d-flex widget has-shadow mr-4 ml-4 mt-2 mb-0 p-2")
            paddingTop = 10.px
            height = 80.px
        }
        props.columns.forEach {
            styledDiv {
                css {
                    classes.add("col-$it p-1")
                }
                styledDiv {
                    css {
                        classes.add("p-2")
                        backgroundColor = Color.lightGray
                        width = 100.pct
                        height = 100.pct
                    }
                    styledDiv {
                        css {
                            backgroundColor = Color.lightSlateGray.withAlpha(0.4)
                            width = 100.pct
                            height = 100.pct
                        }
                    }
                }
            }
        }

        if (undefined != props.name) {
            styledDiv {
                css {
                    color = Color("#2c304d")
                    fontWeight = FontWeight.w600
                    position = Position.absolute
                    left = 0.px
                    right = 0.px
                    textAlign = TextAlign.center
                    paddingTop = 10.px
                }
                +props.name
            }

            styledDiv {
                attrs.onClickFunction = {
                    props.onDelete()
                }
                css {
                    position = Position.absolute
                    right = LinearDimension("28px")
                    backgroundColor = Color("#17a2b8")
                    border(4.px, BorderStyle.solid, Color("#17a2b8"))
                    borderRadius = 8.px
                    cursor = Cursor.pointer
                    zIndex = 20
                }
                styledI {
                    css {
                        classes.add("la la-trash")
                        color = Color.white
                        padding(5.px)
                        cursor = Cursor.move
                        pointerEvents = PointerEvents.none
                    }
                }
            }
        }
    }
}

private external interface RowsContainerProps : Props {
    var mobileMode: Boolean
    var rows: List<EmailTemplateRow>
    var selectedElement: Triple<Int, Int, Int>
    var settings: EmailTemplatePageSettings

    var onElementSelected: (Int, Int, Int) -> Unit
    var onRowsChanged: (List<EmailTemplateRow>) -> Unit
}
private val RowsContainer = fc<RowsContainerProps> { props ->
//    val cb = useCallback(props.rows) {
//        println("${Clock.System.now()}")
//    }
//    val cr = useMemo(props.rows) {
//        return@useMemo props.rows
//    }
    val rowsRef = useRef(props.rows)

    var rows by useState(props.rows)
    useEffect(props.rows) {
        rows = props.rows
        rowsRef.current = props.rows
    }

//    println("render rows ${props.rows.map { r -> r.columns.map { c -> c.blocks.map { b -> b::class.simpleName }} }}")
    props.rows.forEachIndexed { rowIndex, row ->
        rowElement {
            attrs {
                this.mobileMode = props.mobileMode
                this.settings = props.settings
                this.row = row
                this.rowIndex = rowIndex
                this.selectedElement = props.selectedElement
                this.onClick = { a, b, c ->
                    props.onElementSelected(a, b, c)
//                    selectedElement = Triple(a,b,c)
                }
                this.onChange = { newRow ->
                    val newRows = props.rows.toMutableList()
                    newRows[rowIndex] = newRow
                    props.onRowsChanged(newRows)
//                    props.rows = newRows
                }
                this.onDelete = {
                    props.onRowsChanged(props.rows.minus(props.rows[rowIndex]))
//                    props.rows = props.rows.minus(props.rows[rowIndex])
                }
                this.onSave = {
                    window.prompt("Введите название строки", "Новая строка")?.let { name ->
                        Http.put("/templates/rows", EmailTemplateRowData(name = name, row = props.rows[rowIndex])) { response ->
                            response.checkResponseError()?.let { error ->
                                showNotification(error, NotyType.Error)
                                return@put
                            }
                            showNotification("Строка сохранена", NotyType.Success)
                        }
                    }
                }
                this.moveRow = { itm: dynamic, fromRowIndex: Int, toRowIndex: Int, isAbove: Boolean, isCopy: Boolean ->
                    var resultToIndex = if (isAbove) toRowIndex else toRowIndex + 1
                    val newRows = (rowsRef.current ?: props.rows).toMutableList()

                    var newRow = if (fromRowIndex >= 0) {
                        if (isCopy) {
                            newRows[fromRowIndex].copy(
                                options = newRows[fromRowIndex].options.copy(),
                                columns = newRows[fromRowIndex].columns.map { c ->
                                    c.copy(
                                        size = c.size,
                                        blocks = c.blocks.map { b ->
                                            when (b) {
                                                is EmailTemplateBlock.Button -> b.copy()
                                                is EmailTemplateBlock.Header -> b.copy()
                                                is EmailTemplateBlock.Html -> b.copy()
                                                is EmailTemplateBlock.Image -> b.copy()
                                                is EmailTemplateBlock.Video -> b.copy()
                                                is EmailTemplateBlock.List -> b.copy()
                                                is EmailTemplateBlock.Paragraph -> b.copy()
                                                is EmailTemplateBlock.Separator -> b.copy()
                                                is EmailTemplateBlock.Spacer -> b.copy()
                                                is EmailTemplateBlock.Text -> b.copy()
                                            }
                                        }
                                    )
                                }
                            )
                        } else {
                            if (resultToIndex > fromRowIndex) {
                                resultToIndex--
                            }
                            newRows.removeAt(fromRowIndex)
                        }
                    } else {
                        EmailTemplateRow(columns = (itm.columns as Array<Int>).map { EmailTemplateColumn(it) })
                    }

                    if (resultToIndex >= newRows.size) {
                        newRows.add(newRow)
                    } else {
                        newRows.add(max(resultToIndex, 0), newRow)
                    }
                    props.onRowsChanged(newRows)

                }
//                                        this.moveBlock = moveBlock
                this.moveBlock = moveBlock@{ fromRowIndex: Int, toRowIndex: Int, fromColumnIndex: Int, toColumnIndex: Int, fromBlockIndex: Int, toBlockIndex: Int, block1: EmailTemplateBlock, isCopy: Boolean ->
//                    cb()
//                    println("move rows ${props.rows.map { r -> r.columns.map { c -> c.blocks.map { b -> b::class.simpleName }} }}")
//                    println("move row2 ${cr.map { r -> r.columns.map { c -> c.blocks.map { b -> b::class.simpleName }} }}")
//                    println("move row3 ${rows.map { r -> r.columns.map { c -> c.blocks.map { b -> b::class.simpleName }} }}")
//                    println("move row3 ${rowsRef.current?.map { r -> r.columns.map { c -> c.blocks.map { b -> b::class.simpleName }} }}")
//                    println("isCopy: $isCopy")

                    if (fromRowIndex == toRowIndex && fromColumnIndex == toColumnIndex && fromBlockIndex == toBlockIndex && !isCopy) {
                        return@moveBlock
                    }

                    val newRows = (rowsRef.current ?: props.rows).toMutableList()
                    val block = if (fromRowIndex >= 0 && fromColumnIndex >= 0 && fromBlockIndex >= 0) {
                        newRows[fromRowIndex].columns[fromColumnIndex].blocks[fromBlockIndex]
                    } else {
                        block1
                    }
                    val newBlock = if (isCopy) {
                        when (block) {
                            is EmailTemplateBlock.Button -> block.copy()
                            is EmailTemplateBlock.Header -> block.copy()
                            is EmailTemplateBlock.Html -> block.copy()
                            is EmailTemplateBlock.Image -> block.copy()
                            is EmailTemplateBlock.Video -> block.copy()
                            is EmailTemplateBlock.List -> block.copy()
                            is EmailTemplateBlock.Paragraph -> block.copy()
                            is EmailTemplateBlock.Separator -> block.copy()
                            is EmailTemplateBlock.Spacer -> block.copy()
                            is EmailTemplateBlock.Text -> block.copy()
                        }
                    } else {
                        block
                    }

                    var resultBlockIndex = toBlockIndex
                    if (!isCopy && fromRowIndex >= 0 && fromColumnIndex >= 0) {
                        val newColumns = newRows[fromRowIndex].columns.toMutableList()
                        val newBlocks = newColumns[fromColumnIndex].blocks.minus(block).toList()

                        if (fromRowIndex == toRowIndex && fromColumnIndex == toColumnIndex && fromBlockIndex in 0 until resultBlockIndex) {
                            resultBlockIndex--
                        }
                        newColumns[fromColumnIndex] = newColumns[fromColumnIndex].copy(blocks = newBlocks)
                        newRows[fromRowIndex] = newRows[fromRowIndex].copy(columns = newColumns.toList())
                    }

//                    println("move row2 ${newRows.map { r -> r.columns.map { c -> c.blocks.map { b -> b::class.simpleName }} }}")
//                    println("size: ${toRowIndex} ${newRows.size}")
//        val newRow = newRows.removeAt(toRowIndex)
                    val newRowColumns = newRows[toRowIndex].columns.toMutableList()
                    val newBlocks = newRowColumns[toColumnIndex].blocks.toMutableList()

                    if (resultBlockIndex < 0)
                        resultBlockIndex = toBlockIndex

                    if (resultBlockIndex < 0 || resultBlockIndex >= newBlocks.size) {
                        newBlocks.add(newBlock)
                    } else {
                        newBlocks.add(resultBlockIndex, newBlock)
                    }

                    newRowColumns[toColumnIndex] = newRowColumns[toColumnIndex].copy(blocks = newBlocks.toList())
                    newRows[toRowIndex] = newRows[toRowIndex].copy(columns = newRowColumns.toList())
//                        rows = newRows
//                    println("move row3 ${newRows.map { r -> r.columns.map { c -> c.blocks.map { b -> b::class.simpleName }} }}")
                    props.onRowsChanged(newRows)
                }
//                                                { fromRowIndex: Int, toRowIndex: Int, fromColumnIndex: Int, toColumnIndex: Int, fromBlockIndex: Int, toBlockIndex: Int, block: EmailTemplateBlock, isCopy: Boolean ->
//                                                println("mb: ${rows.size}")
//                                                moveBlock(fromRowIndex, toRowIndex, fromColumnIndex, toColumnIndex, fromBlockIndex, toBlockIndex, block, isCopy)
//                                            }
                this.onDrop = { itm, isAbove ->

                    val index = itm.index as Int
                    if (index != rowIndex) {
                        val result = props.rows.toMutableList()
                        val tmp = if (index != -1) result.removeAt(index) else EmailTemplateRow(columns = (itm.columns as Array<Int>).map { EmailTemplateColumn(it) })

                        when {
                            isAbove -> {
                                result.add(if (index != -1 && index < rowIndex) rowIndex - 1 else rowIndex, tmp)
                            }
                            result.size <= rowIndex + 1 -> {
                                result.add(tmp)
                            }
                            else -> {
                                result.add(maxOf(rowIndex + 1, result.size), tmp)
                            }
                        }

                        props.onRowsChanged(result)
//                            rows = result
                    }
                }
            }
        }

    }
}